// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js!./analytics-panel.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js!./tournament-ui.css";
import ___CSS_LOADER_AT_RULE_IMPORT_2___ from "-!../../../node_modules/css-loader/dist/cjs.js!./animations.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * game-ui.css - Styling for Memex Racing UI Components
 * 
 * Retro pixel art aesthetic with terminal green (#00ff00) on black backgrounds,
 * Courier New font, and responsive design for racing game interface.
 * Includes styles for Track Editor, Live Preview, and Analytics Panel components.
 */

/* Import Analytics Panel Styles */

/* Import Tournament UI Styles */

/* Import Animation Styles */

/* ===== BASE STYLES ===== */
.ui-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    pointer-events: none;
    z-index: 1000;
    font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace;
    color: #00ff00;
    font-size: 14px;
    line-height: 1.4;
}

.ui-overlay * {
    box-sizing: border-box;
}

/* ===== PANEL BASE STYLES ===== */
.ui-panel {
    position: absolute;
    background: rgba(0, 0, 0, 0.9);
    border: none; /* Removed green border per user request */
    border-radius: 4px;
    pointer-events: auto;
    backdrop-filter: blur(5px);
    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);
    min-width: 200px;
    max-width: 400px;
}

.ui-panel.hidden {
    display: none !important;
}

.panel-header {
    background: #00ff00;
    color: #000;
    padding: 8px 12px;
    font-weight: bold;
    font-size: 16px;
    border-bottom: 2px solid #00ff00;
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.panel-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.panel-body {
    padding: 12px;
    max-height: 400px;
    overflow-y: auto;
}

.panel-body::-webkit-scrollbar {
    width: 8px;
}

.panel-body::-webkit-scrollbar-track {
    background: #000;
}

.panel-body::-webkit-scrollbar-thumb {
    background: #00ff00;
    border-radius: 4px;
}

/* ===== PLAYER INFO PANEL ===== */
/* REMOVED - Player info panel was removed per changelog requirements */
/* The panel is no longer created in UIManager.js so these styles are unused */
/*
.player-info {
    top: 20px;
    left: 20px;
    width: 250px;
}

.player-details {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.detail-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
}

.detail-row:last-child {
    border-bottom: none;
}

.label {
    font-weight: bold;
    color: #00ff00;
}

.value {
    color: #ffffff;
}

.status-menu { color: #00ff00; }
.status-lobby { color: #ffff00; }
.status-betting { color: #ff8800; }
.status-racing { color: #ff0000; }
*/
.status-finished { color: #00ff00; }

/* ===== BETTING PANEL ===== */
.betting-panel {
    bottom: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 600px;
    max-width: 90vw;
}

.countdown-timer {
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid #ff0000;
    border-radius: 4px;
    padding: 4px 8px;
    font-weight: bold;
    color: #ff0000;
}

.countdown-timer.warning {
    background: rgba(255, 255, 0, 0.2);
    border-color: #ffff00;
    color: #ffff00;
}

.countdown-timer.urgent {
    background: rgba(255, 0, 0, 0.4);
    border-color: #ff0000;
    color: #ff0000;
    animation: pulse 0.5s infinite alternate;
}

@keyframes pulse {
    from { opacity: 0.7; }
    to { opacity: 1; }
}

.betting-status {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
    padding: 8px;
    background: rgba(0, 255, 0, 0.1);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
}

.balance-display, .current-bet-display {
    display: flex;
    gap: 8px;
}

.current-bet-display .value.has-bet {
    color: #ffff00;
    font-weight: bold;
}

.balance-display .value.low-balance {
    color: #ff8800;
}

.balance-display .value.no-balance {
    color: #ff0000;
    font-weight: bold;
}

.players-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
    gap: 8px;
    margin-bottom: 12px;
}

.player-card {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.player-card:hover {
    background: rgba(0, 255, 0, 0.1);
    border-color: #00ff00;
    transform: translateY(-2px);
}

.player-card.selected {
    background: rgba(255, 255, 0, 0.2);
    border-color: #ffff00;
    box-shadow: 0 0 10px rgba(255, 255, 0, 0.3);
}

.player-card .player-info {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 6px;
}

.player-avatar {
    width: 24px;
    height: 24px;
    background: #00ff00;
    color: #000;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 12px;
    flex-shrink: 0;
}

.player-details {
    flex: 1;
}

.player-name {
    font-weight: bold;
    font-size: 12px;
    display: block;
}

.player-stats {
    font-size: 10px;
    color: #aaa;
    display: flex;
    gap: 8px;
}

.betting-info {
    display: flex;
    justify-content: space-between;
    margin-bottom: 6px;
    font-size: 11px;
}

.odds-display, .pool-display {
    text-align: center;
}

.odds-label, .pool-label {
    display: block;
    color: #888;
    font-size: 10px;
}

.odds-value {
    color: #00ff00;
    font-weight: bold;
}

.pool-value {
    color: #ffff00;
}

.bet-button {
    width: 100%;
    background: #00ff00;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 6px;
    font-family: inherit;
    font-weight: bold;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.bet-button:hover:not(:disabled) {
    background: #00cc00;
    transform: scale(1.05);
}

.bet-button:disabled {
    background: #333;
    color: #666;
    cursor: not-allowed;
}

.betting-controls {
    margin-bottom: 12px;
}

.bet-amount-section {
    margin-bottom: 8px;
}

.bet-amount-section label {
    display: block;
    margin-bottom: 4px;
    font-weight: bold;
}

.slider-container {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

#bet-amount-slider {
    width: 100%;
    height: 6px;
    background: #333;
    outline: none;
    border-radius: 3px;
}

#bet-amount-slider::-webkit-slider-thumb {
    appearance: none;
    width: 16px;
    height: 16px;
    background: #00ff00;
    cursor: pointer;
    border-radius: 50%;
}

#bet-amount-slider::-moz-range-thumb {
    width: 16px;
    height: 16px;
    background: #00ff00;
    cursor: pointer;
    border-radius: 50%;
    border: none;
}

.slider-presets {
    display: flex;
    gap: 4px;
    justify-content: space-between;
}

.preset-btn {
    flex: 1;
    background: rgba(0, 255, 0, 0.2);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 4px;
    padding: 4px;
    font-family: inherit;
    font-size: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.preset-btn:hover {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
}

.bet-actions {
    display: flex;
    gap: 8px;
}

.action-btn {
    flex: 1;
    background: rgba(0, 255, 0, 0.2);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 4px;
    padding: 8px;
    font-family: inherit;
    font-weight: bold;
    font-size: 12px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.action-btn:hover:not(:disabled) {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
    transform: translateY(-1px);
}

.action-btn:disabled {
    background: rgba(100, 100, 100, 0.1);
    color: #666;
    border-color: #333;
    cursor: not-allowed;
}

.betting-stats {
    border-top: 1px solid rgba(0, 255, 0, 0.3);
    padding-top: 8px;
    display: flex;
    justify-content: space-between;
}

.stats-row {
    display: flex;
    gap: 8px;
}

.stat-label {
    color: #888;
    font-size: 11px;
}

.stat-value {
    color: #00ff00;
    font-weight: bold;
    font-size: 11px;
}

.stat-value.has-potential {
    color: #ffff00;
}

.panel-controls {
    display: flex;
    gap: 4px;
}

.control-btn {
    background: #000;
    color: #00ff00;
    border: 1px solid #00ff00;
    border-radius: 3px;
    padding: 2px 6px;
    cursor: pointer;
    font-family: inherit;
    font-size: 12px;
}

.control-btn:hover {
    background: #00ff00;
    color: #000;
}

.sort-controls, .time-filter {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 11px;
}

.sort-controls label, .time-filter label {
    font-weight: bold;
    color: #00ff00;
    white-space: nowrap;
}

.sort-controls select, .time-filter select {
    flex: 1;
    background: #000;
    color: #00ff00;
    border: 1px solid #00ff00;
    border-radius: 3px;
    padding: 3px 6px;
    font-family: inherit;
    font-size: 11px;
}

.sort-order-btn {
    background: #00ff00;
    color: #000;
    border: none;
    border-radius: 3px;
    padding: 3px 8px;
    cursor: pointer;
    font-family: inherit;
    font-weight: bold;
    font-size: 11px;
}

.sort-order-btn:hover {
    background: #00cc00;
}


.table-header {
    display: grid;
    grid-template-columns: 50px 1fr 80px 60px;
    gap: 8px;
    padding: 8px;
    background: rgba(0, 255, 0, 0.2);
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
    font-weight: bold;
    font-size: 11px;
}

.table-body {
    max-height: 300px;
    overflow-y: auto;
}

.table-body.updating {
    opacity: 0.7;
    transition: opacity 0.3s ease;
}

.player-row {
    display: grid;
    grid-template-columns: 50px 1fr 80px 60px;
    gap: 8px;
    padding: 6px 8px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.1);
    font-size: 10px;
    transition: all 0.2s ease;
}

.player-row:hover {
    background: rgba(0, 255, 0, 0.1);
}

.player-row.rank-1 {
    background: rgba(255, 215, 0, 0.1);
    border-color: rgba(255, 215, 0, 0.3);
}

.player-row.rank-2 {
    background: rgba(192, 192, 192, 0.1);
    border-color: rgba(192, 192, 192, 0.3);
}

.player-row.rank-3 {
    background: rgba(205, 127, 50, 0.1);
    border-color: rgba(205, 127, 50, 0.3);
}

.rank-col {
    display: flex;
    align-items: center;
    gap: 4px;
}

.rank-number {
    font-weight: bold;
    color: #00ff00;
}

.rank-medal {
    font-size: 12px;
}

.player-col .player-info {
    display: flex;
    align-items: center;
    gap: 6px;
}

.player-col .player-avatar {
    width: 16px;
    height: 16px;
    font-size: 10px;
    flex-shrink: 0;
}

.player-details {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.player-name {
    font-weight: bold;
    color: #fff;
    font-size: 10px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.player-status {
    font-size: 8px;
    display: flex;
    align-items: center;
    gap: 2px;
}

.player-status.online {
    color: #00ff00;
}

.player-status.offline {
    color: #666;
}

.stats-col {
    display: flex;
    flex-direction: column;
    gap: 2px;
    font-size: 9px;
}

.stat-item {
    display: flex;
    justify-content: space-between;
    gap: 4px;
}

.stat-label {
    color: #888;
}

.stat-value.win-rate {
    color: #ffff00;
}

.stat-value.wins {
    color: #00ff00;
}

.score-col {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.score-value {
    font-weight: bold;
    color: #00ff00;
    font-size: 11px;
}

.score-label {
    color: #888;
    font-size: 8px;
}


.summary-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 2px;
}

.summary-item .label {
    color: #888;
    font-size: 9px;
}

.summary-item .value {
    color: #00ff00;
    font-weight: bold;
}

.recent-winners {
    border-top: 1px solid rgba(0, 255, 0, 0.3);
    padding-top: 8px;
}

.section-header {
    font-weight: bold;
    color: #00ff00;
    font-size: 11px;
    margin-bottom: 6px;
}

.winners-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.winner-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 4px;
    background: rgba(0, 255, 0, 0.05);
    border-radius: 3px;
    font-size: 10px;
}

.winner-avatar {
    font-size: 12px;
}

.winner-name {
    flex: 1;
    color: #fff;
    font-weight: bold;
}

.winner-time {
    color: #888;
    font-size: 9px;
}

.no-winners {
    text-align: center;
    color: #666;
    font-style: italic;
    font-size: 10px;
    padding: 8px;
}

/* ===== DEBUG PANEL ===== */
.debug-panel {
    bottom: 20px;
    left: 20px;
    width: 350px;
    max-height: 80vh;
    overflow-y: auto;
}

.debug-content {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.debug-section {
    border: 1px solid rgba(255, 255, 0, 0.3);
    border-radius: 4px;
    padding: 8px;
    background: rgba(255, 255, 0, 0.05);
    position: relative;
}

.debug-section h4 {
    color: #ffff00;
    font-size: 12px;
    margin: 0 0 8px 0;
    font-weight: bold;
    text-transform: uppercase;
}

.section-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.section-header h4 {
    margin: 0;
    flex: 1;
}

.section-header .toggle-btn {
    background: rgba(255, 255, 0, 0.2);
    border: 1px solid rgba(255, 255, 0, 0.4);
    color: #ffff00;
    font-size: 14px;
    padding: 2px 6px;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.section-header .toggle-btn:hover {
    background: rgba(255, 255, 0, 0.3);
    border-color: #ffff00;
}

.section-header .clear-btn {
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid rgba(255, 0, 0, 0.4);
    color: #ff6666;
    font-size: 12px;
    padding: 2px 6px;
    border-radius: 3px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.section-header .clear-btn:hover {
    background: rgba(255, 0, 0, 0.3);
    border-color: #ff0000;
}

/* Debug active indicator */
.debug-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 11px;
}

.status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #666;
    transition: background 0.3s ease;
}

.status-dot.active {
    background: #00ff00;
    box-shadow: 0 0 8px rgba(0, 255, 0, 0.5);
}

.status-text {
    font-weight: bold;
    color: #666;
    transition: color 0.3s ease;
}

.status-dot.active + .status-text {
    color: #00ff00;
}

/* Debug grid layout */
.debug-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-bottom: 8px;
}

.debug-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    padding: 4px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
}

.debug-info .label {
    color: #888;
    font-weight: bold;
}

.debug-info .value {
    color: #fff;
    font-weight: normal;
}

.debug-info .value.on-track {
    color: #00ff00;
}

.debug-info .value.off-track {
    color: #ff0000;
}

/* Problem areas list */
.problem-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-height: 120px;
    overflow-y: auto;
}

.problem-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px;
    background: rgba(0, 0, 0, 0.4);
    border-radius: 3px;
    border-left: 3px solid;
    font-size: 10px;
}

.problem-item.severity-high {
    border-left-color: #ff0000;
    background: rgba(255, 0, 0, 0.1);
}

.problem-item.severity-medium {
    border-left-color: #ffaa00;
    background: rgba(255, 170, 0, 0.1);
}

.problem-item.severity-low {
    border-left-color: #ffff00;
    background: rgba(255, 255, 0, 0.1);
}

.problem-rank {
    font-weight: bold;
    color: #ffff00;
    min-width: 20px;
}

.problem-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.problem-location {
    color: #fff;
    font-weight: bold;
}

.problem-count {
    color: #888;
    font-size: 9px;
}

.problem-actions {
    display: flex;
    gap: 4px;
}

.teleport-btn {
    background: rgba(0, 255, 255, 0.2);
    border: none;
    color: #00ffff;
    font-size: 12px;
    padding: 2px 4px;
    border-radius: 2px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.teleport-btn:hover {
    background: rgba(0, 255, 255, 0.4);
}

.no-problems,
.no-history {
    text-align: center;
    color: #666;
    font-style: italic;
    font-size: 10px;
    padding: 12px;
}

/* Position history list */
.position-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    max-height: 100px;
    overflow-y: auto;
    font-size: 10px;
}

.position-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 6px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 2px;
    transition: background 0.2s ease;
}

.position-item.current {
    background: rgba(255, 255, 0, 0.2);
    border: 1px solid rgba(255, 255, 0, 0.4);
}

.position-index {
    font-weight: bold;
    color: #ffff00;
    min-width: 16px;
}

.position-coords {
    color: #fff;
    flex: 1;
}

.position-time {
    color: #888;
    font-size: 9px;
}

/* Visual controls */
.control-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
}

.control-item {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 10px;
    padding: 4px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
}

.control-item input[type="checkbox"] {
    width: 14px;
    height: 14px;
    accent-color: #ffff00;
}

.control-item span {
    color: #ccc;
    font-size: 10px;
}

/* Performance section specific styles */
.performance-info .debug-grid {
    grid-template-columns: 1fr;
}

/* Legacy debug styles for compatibility */
#fps-counter {
    color: #ffff00;
}

#memory-usage {
    color: #ff8800;
}

#connection-status {
    color: #00ff00;
}

/* Debug panel responsive adjustments */
@media (max-width: 768px) {
    .debug-panel {
        width: 90vw;
        left: 5vw;
        bottom: 10px;
        max-height: 70vh;
    }
    
    .debug-grid {
        grid-template-columns: 1fr;
    }
    
    .control-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 480px) {
    .debug-panel {
        width: calc(100vw - 20px);
        left: 10px;
    }
    
    .section-header {
        flex-direction: column;
        align-items: stretch;
        gap: 4px;
    }
    
    .section-header h4 {
        text-align: center;
    }
    
    .section-header .toggle-btn,
    .section-header .clear-btn {
        width: 100%;
        text-align: center;
    }
}

/* ===== INVITE MODAL ===== */
.modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    pointer-events: auto;
}

.modal-overlay.hidden {
    display: none !important;
}

.modal-content {
    background: #000;
    border: none;
    border-radius: 8px;
    max-width: 600px;
    width: 90vw;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
}

.invite-content {
    width: 100%;
}

.modal-header {
    background: #00ff00;
    color: #000;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: none;
}

.modal-header h2 {
    margin: 0;
    font-size: 18px;
    font-weight: bold;
}

.close-btn {
    background: none;
    border: none;
    color: #000;
    font-size: 24px;
    cursor: pointer;
    padding: 0;
    width: 30px;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    transition: background 0.2s ease;
}

.close-btn:hover {
    background: rgba(0, 0, 0, 0.2);
}

.modal-body {
    padding: 20px;
    color: #00ff00;
}

.room-code-section, .share-link-section, .qr-code-section, .social-share-section {
    margin-bottom: 20px;
    padding: 16px;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 6px;
    background: rgba(0, 255, 0, 0.05);
}

.room-code-section h3, .share-link-section h3, .qr-code-section h3, .social-share-section h3 {
    margin: 0 0 12px 0;
    color: #00ff00;
    font-size: 14px;
    font-weight: bold;
}

.room-code-display, .share-link-display {
    display: flex;
    gap: 8px;
    align-items: center;
}

#room-code-text {
    background: #000;
    color: #00ff00;
    padding: 12px 16px;
    border: 2px solid #00ff00;
    border-radius: 4px;
    font-size: 24px;
    font-weight: bold;
    letter-spacing: 2px;
    text-align: center;
    flex: 1;
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
}

#share-link-input {
    background: #000;
    color: #00ff00;
    border: 1px solid #00ff00;
    border-radius: 4px;
    padding: 8px 12px;
    font-family: inherit;
    font-size: 12px;
    flex: 1;
}

.copy-btn {
    background: #00ff00;
    color: #000;
    border: none;
    border-radius: 4px;
    padding: 8px 12px;
    font-family: inherit;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.copy-btn:hover {
    background: #00cc00;
    transform: translateY(-1px);
}

.copy-btn.copy-success {
    background: #00aa00;
    color: #fff;
}

.copy-btn.copy-error {
    background: #aa0000;
    color: #fff;
}

.qr-code-container {
    display: flex;
    justify-content: center;
    align-items: center;
    min-height: 200px;
    position: relative;
}

#qr-code-canvas {
    border: 2px solid #00ff00;
    border-radius: 4px;
    background: #fff;
    display: none;
}

.qr-code-placeholder {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    color: #888;
}

.loading-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid rgba(0, 255, 0, 0.3);
    border-top: none;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

.social-buttons {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
    gap: 8px;
}

.social-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 4px;
    padding: 10px 12px;
    font-family: inherit;
    font-weight: bold;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s ease;
    font-size: 11px;
}

.social-btn:hover {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
    transform: translateY(-1px);
}

.twitter-btn:hover {
    background: rgba(29, 161, 242, 0.3);
    border-color: #1da1f2;
    color: #1da1f2;
}

.discord-btn:hover {
    background: rgba(114, 137, 218, 0.3);
    border-color: #7289da;
    color: #7289da;
}

.whatsapp-btn:hover {
    background: rgba(37, 211, 102, 0.3);
    border-color: #25d366;
    color: #25d366;
}

.email-btn:hover {
    background: rgba(234, 67, 53, 0.3);
    border-color: #ea4335;
    color: #ea4335;
}

.quick-actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-top: 20px;
}

.quick-actions .action-btn {
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 6px;
    min-width: 120px;
}

.quick-actions .action-btn.enabled {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
    color: #00ff00;
}

.quick-actions .action-btn.enabled:hover {
    background: #00ff00;
    color: #000;
}

/* ===== RACE TIMER ===== */
.race-timer {
    position: absolute;
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    background: rgba(255, 0, 0, 0.9);
    color: #fff;
    padding: 8px 16px;
    border: 2px solid #ff0000;
    border-radius: 6px;
    font-size: 18px;
    font-weight: bold;
    box-shadow: 0 0 20px rgba(255, 0, 0, 0.5);
    pointer-events: auto;
}

.race-timer.hidden {
    display: none !important;
}

/* ===== PANEL TOGGLES ===== */
.panel-toggles {
    position: absolute;
    bottom: 20px;
    right: 20px;
    display: flex;
    flex-direction: column;
    gap: 4px;
    pointer-events: auto;
}

.toggle-btn {
    background: rgba(0, 0, 0, 0.8);
    color: #00ff00;
    border: 1px solid #00ff00;
    border-radius: 4px;
    padding: 6px 8px;
    font-family: inherit;
    font-size: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    white-space: nowrap;
}

.toggle-btn:hover {
    background: #00ff00;
    color: #000;
    transform: translateX(-2px);
}

/* ===== NOTIFICATIONS ===== */
.notification {
    position: absolute;
    bottom: -40px;
    left: 50%;
    transform: translateX(-50%);
    background: #000;
    color: #00ff00;
    border: 1px solid #00ff00;
    border-radius: 4px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: bold;
    white-space: nowrap;
    pointer-events: none;
    opacity: 0;
    transition: all 0.3s ease;
    z-index: 1001;
}

.notification.show {
    opacity: 1;
    bottom: -30px;
}

.notification.success {
    background: rgba(0, 255, 0, 0.2);
    border-color: #00ff00;
    color: #00ff00;
}

.notification.error {
    background: rgba(255, 0, 0, 0.2);
    border-color: #ff0000;
    color: #ff0000;
}

.notification.info {
    background: rgba(0, 255, 255, 0.2);
    border-color: #00ffff;
    color: #00ffff;
}

/* ===== RESPONSIVE DESIGN ===== */
@media (max-width: 768px) {
    .ui-panel {
        max-width: 90vw;
    }
    
    .player-info {
        width: 200px;
    }
    
    .betting-panel {
        width: 90vw;
    }
    
    .leaderboard-panel {
        width: 90vw;
        right: 5vw;
    }
    
    .modal-content {
        width: 95vw;
        margin: 10px;
    }
    
    .social-buttons {
        grid-template-columns: repeat(2, 1fr);
    }
    
    .quick-actions {
        flex-direction: column;
    }
    
    .players-grid {
        grid-template-columns: 1fr;
    }
    
    .panel-toggles {
        flex-direction: row;
        bottom: 10px;
        right: 10px;
    }
}

@media (max-width: 480px) {
    .ui-overlay {
        font-size: 12px;
    }
    
    .player-info {
        top: 10px;
        left: 10px;
        width: calc(100vw - 20px);
        max-width: 250px;
    }
    
    .betting-panel {
        bottom: 60px;
        width: calc(100vw - 20px);
    }
    
    .leaderboard-panel {
        top: 10px;
        right: 10px;
        width: calc(100vw - 20px);
        max-width: 300px;
    }
    
    .debug-panel {
        bottom: 10px;
        left: 10px;
        width: calc(100vw - 20px);
        max-width: 250px;
    }
    
    #room-code-text {
        font-size: 18px;
        padding: 8px 12px;
    }
    
    .room-code-display, .share-link-display {
        flex-direction: column;
        gap: 6px;
    }
    
    .copy-btn {
        width: 100%;
        justify-content: center;
    }
}

/* ===== ACCESSIBILITY ===== */
@media (prefers-reduced-motion: reduce) {
    *, *::before, *::after {
        animation-duration: 0.01ms !important;
        animation-iteration-count: 1 !important;
        transition-duration: 0.01ms !important;
    }
    
    .loading-spinner {
        animation: none;
        border: none;
    }
}

/* Focus styles for keyboard navigation */
.ui-panel:focus,
.toggle-btn:focus,
.action-btn:focus,
.bet-button:focus,
.copy-btn:focus,
.social-btn:focus {
    outline: 2px solid #ffff00;
    outline-offset: 2px;
}

/* High contrast mode support */
@media (prefers-contrast: high) {
    .ui-panel {
        border-width: 3px;
        background: #000;
    }
    
    .panel-header {
        background: #00ff00;
        color: #000;
    }
    
    .notification {
        border-width: 2px;
    }
}

/* ===== MAP SELECTION PANEL ===== */
.map-selection-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.85);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    pointer-events: auto;
}

.map-selection-modal {
    background: #000;
    border: none;
    border-radius: 8px;
    max-width: 800px;
    width: 90vw;
    max-height: 90vh;
    overflow-y: auto;
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
}

.map-selection-content {
    width: 100%;
}

.map-selection-panel .panel-header {
    background: #00ff00;
    color: #000;
    padding: 12px 16px;
    border-bottom: none;
}

.map-selection-panel .panel-title {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: 100%;
}

.pixel-text {
    font-family: 'Courier New', monospace;
    font-weight: bold;
    text-transform: uppercase;
    font-size: 18px;
    text-align: center;
}

.rotation-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
    color: #000;
}

.rotation-text {
    font-weight: bold;
}

.race-counter {
    display: flex;
    gap: 6px;
    align-items: center;
}

.race-counter .label {
    font-weight: normal;
}

.race-counter .value {
    font-weight: bold;
    color: #ff0000;
}

.map-selection-content .panel-body {
    padding: 20px;
    color: #00ff00;
}

.maps-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 16px;
    margin-bottom: 20px;
}

.map-option {
    background: rgba(0, 255, 0, 0.05);
    border: 2px solid rgba(0, 255, 0, 0.3);
    border-radius: 8px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
}

.map-option:hover {
    border-color: #ffff00;
    box-shadow: 0 0 15px rgba(255, 255, 0, 0.3);
    transform: translateY(-2px);
}

.map-option.selected {
    border-color: #ffff00;
    border-width: 4px;
    background: rgba(255, 255, 0, 0.1);
    box-shadow: 0 0 20px rgba(255, 255, 0, 0.4);
}

.map-preview {
    width: 100%;
    height: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    border-radius: 4px;
    overflow: hidden;
    background: #111;
}

.preview-canvas {
    width: 100%;
    height: 100%;
    object-fit: cover;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

.map-info {
    text-align: center;
}

.map-title {
    font-weight: bold;
    font-size: 14px;
    color: #00ff00;
    margin-bottom: 4px;
}

.map-difficulty-badge {
    display: inline-block;
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: bold;
    text-transform: uppercase;
}

.difficulty-easy {
    background: rgba(0, 255, 0, 0.2);
    color: #00ff00;
    border: 1px solid #00ff00;
}

.difficulty-medium {
    background: rgba(255, 255, 0, 0.2);
    color: #ffff00;
    border: 1px solid #ffff00;
}

.difficulty-hard {
    background: rgba(255, 165, 0, 0.2);
    color: #ffa500;
    border: 1px solid #ffa500;
}

.difficulty-very-hard {
    background: rgba(255, 0, 0, 0.2);
    color: #ff0000;
    border: 1px solid #ff0000;
}

.selection-info {
    margin-bottom: 20px;
    padding: 16px;
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 6px;
}

.selected-map-details {
    text-align: center;
}

.map-name {
    font-size: 20px;
    font-weight: bold;
    color: #00ff00;
    margin-bottom: 8px;
}

.map-description {
    font-size: 14px;
    color: #ccc;
    margin-bottom: 8px;
}

.map-difficulty {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-size: 12px;
}

.difficulty-label {
    color: #888;
}

.difficulty-value {
    font-weight: bold;
}

.selection-controls {
    display: flex;
    gap: 12px;
    justify-content: center;
    margin-bottom: 20px;
}

.selection-controls .action-btn {
    padding: 12px 20px;
    font-size: 14px;
    border-radius: 6px;
    min-width: 140px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    transition: all 0.2s ease;
}

.confirm-btn {
    background: rgba(0, 255, 0, 0.3);
    border: 2px solid #00ff00;
    color: #00ff00;
}

.confirm-btn:hover {
    background: #00ff00;
    color: #000;
    transform: translateY(-1px);
}

.random-btn {
    background: rgba(255, 255, 0, 0.3);
    border: 2px solid #ffff00;
    color: #ffff00;
}

.random-btn:hover {
    background: #ffff00;
    color: #000;
    transform: translateY(-1px);
}

.cancel-btn {
    background: rgba(255, 0, 0, 0.3);
    border: 2px solid #ff0000;
    color: #ff0000;
}

.cancel-btn:hover {
    background: #ff0000;
    color: #fff;
    transform: translateY(-1px);
}

.current-map-info {
    border-top: 1px solid rgba(0, 255, 0, 0.3);
    padding-top: 16px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.info-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}

.info-row .label {
    color: #888;
}

.info-row .value {
    color: #00ff00;
    font-weight: bold;
}

.btn-icon {
    font-size: 16px;
}

/* Map selection notifications */
#map-selection-notification {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background: rgba(0, 0, 0, 0.9);
    border: 2px solid #00ff00;
    border-radius: 6px;
    padding: 12px 20px;
    font-size: 14px;
    font-weight: bold;
    z-index: 2001;
    pointer-events: none;
    opacity: 0;
    transition: all 0.3s ease;
}

#map-selection-notification.show {
    opacity: 1;
}

#map-selection-notification.success {
    border-color: #00ff00;
    color: #00ff00;
    background: rgba(0, 255, 0, 0.1);
}

#map-selection-notification.error {
    border-color: #ff0000;
    color: #ff0000;
    background: rgba(255, 0, 0, 0.1);
}

#map-selection-notification.info {
    border-color: #00ffff;
    color: #00ffff;
    background: rgba(0, 255, 255, 0.1);
}

/* Responsive design for map selection */
@media (max-width: 768px) {
    .map-selection-modal {
        width: 95vw;
        max-height: 95vh;
    }
    
    .maps-grid {
        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
        gap: 12px;
    }
    
    .map-preview {
        height: 100px;
    }
    
    .selection-controls {
        flex-direction: column;
    }
    
    .selection-controls .action-btn {
        min-width: auto;
        width: 100%;
    }
}

@media (max-width: 480px) {
    .map-selection-content .panel-body {
        padding: 15px;
    }
    
    .maps-grid {
        grid-template-columns: 1fr;
        gap: 10px;
    }
    
    .map-preview {
        height: 120px;
    }
    
    .pixel-text {
        font-size: 16px;
    }
    
    .rotation-info {
        flex-direction: column;
        gap: 4px;
        text-align: center;
    }
}

/* ===== PLAYER SETUP PANEL ===== */
.ui-panel.player-setup {
    top: 10px;
    right: 10px;
    width: 320px;
    max-height: 90vh;
    overflow-y: auto;
}

.current-player-display {
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    padding: 10px;
    margin-bottom: 15px;
    background: rgba(0, 255, 0, 0.1);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
}

.player-customization-section {
    margin-bottom: 20px;
}

.customization-container {
    padding: 10px;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
}

.name-input-section {
    margin-bottom: 15px;
}

.input-label {
    display: block;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 5px;
    color: #00ff00;
}

.player-name-input {
    width: 100%;
    padding: 8px;
    background: #000;
    color: #00ff00;
    border: 2px solid #00ff00;
    border-radius: 3px;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    text-transform: uppercase;
}

.player-name-input:focus {
    outline: none;
    border-color: #00ff00;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.5);
}

.input-hint {
    font-size: 11px;
    color: #888;
    margin-top: 3px;
}

.image-upload-section {
    text-align: center;
}

.file-upload-btn {
    display: inline-block;
    cursor: pointer;
    background: #0066ff;
    color: #fff;
    padding: 8px 15px;
    margin: 10px 0;
    border: 2px solid #0088ff;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    font-weight: bold;
    text-transform: uppercase;
    transition: background 0.2s ease;
}

.file-upload-btn:hover {
    background: #0044cc;
    border-color: #0066ff;
}

.btn-icon {
    margin-right: 5px;
}

.image-preview-container {
    margin: 10px 0;
}

.player-preview {
    max-width: 128px;
    max-height: 128px;
    border: 2px solid #00ff00;
    border-radius: 4px;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

.upload-hints {
    margin-top: 10px;
}

.hint-item {
    font-size: 10px;
    color: #888;
    margin: 2px 0;
}

.join-race-section {
    margin-bottom: 20px;
    text-align: center;
}

.join-race-btn {
    width: 100%;
    padding: 12px;
    background: #00ff00;
    color: #000;
    border: 2px solid #00ff00;
    border-radius: 4px;
    font-family: 'Courier New', monospace;
    font-size: 14px;
    font-weight: bold;
    text-transform: uppercase;
    cursor: pointer;
    transition: all 0.2s ease;
}

.join-race-btn:hover:not(:disabled) {
    background: #00cc00;
    border-color: #00cc00;
    transform: translateY(-1px);
}

.join-race-btn:disabled,
.join-race-btn.joined {
    background: #666;
    border-color: #666;
    cursor: not-allowed;
    transform: none;
}

.join-status {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-top: 10px;
    padding: 8px;
    background: rgba(0, 255, 0, 0.1);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    color: #00ff00;
    font-size: 12px;
}

.status-icon {
    font-size: 16px;
}

.preparation-info,
.controls-help {
    margin-bottom: 15px;
    padding: 10px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
}

.info-header,
.help-header {
    font-size: 12px;
    font-weight: bold;
    color: #00ff00;
    margin-bottom: 8px;
    text-transform: uppercase;
}

.info-content,
.help-content {
    font-size: 11px;
}

.info-item,
.control-item {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 5px 0;
}

.info-icon {
    font-size: 14px;
    width: 16px;
    text-align: center;
}

.key-badge {
    background: #333;
    color: #00ff00;
    padding: 2px 6px;
    border-radius: 3px;
    font-size: 10px;
    font-weight: bold;
    min-width: 20px;
    text-align: center;
}

.control-desc {
    color: #ccc;
    font-size: 11px;
}

.current-map-display {
    padding: 10px;
    background: rgba(0, 0, 0, 0.5);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
}

.map-info-header {
    font-size: 12px;
    font-weight: bold;
    color: #00ff00;
    margin-bottom: 8px;
    text-transform: uppercase;
}

.map-info-content {
    font-size: 11px;
}

.map-name {
    color: #fff;
    font-weight: bold;
    margin-bottom: 5px;
}

.map-rotation-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.rotation-label {
    color: #888;
}

.rotation-count {
    color: #ffff00;
    font-weight: bold;
}

/* Drag and drop styling */
.ui-panel.player-setup.drag-over {
    border-color: #ffff00;
    box-shadow: 0 0 20px rgba(255, 255, 0, 0.5);
}

.ui-panel.player-setup.drag-over .customization-container {
    border-color: #ffff00;
    background: rgba(255, 255, 0, 0.1);
}

/* Player setup notification */
#player-setup-notification {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    padding: 8px;
    border-radius: 4px;
    font-size: 11px;
    text-align: center;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
    pointer-events: none;
}

#player-setup-notification.show {
    opacity: 1;
    transform: translateY(0);
}

#player-setup-notification.success {
    background: rgba(0, 255, 0, 0.2);
    border: 1px solid #00ff00;
    color: #00ff00;
}

#player-setup-notification.error {
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid #ff0000;
    color: #ff6666;
}

#player-setup-notification.info {
    background: rgba(0, 150, 255, 0.2);
    border: 1px solid #0096ff;
    color: #66ccff;
}

/* Responsive adjustments for player setup */
@media (max-width: 768px) {
    .ui-panel.player-setup {
        width: 90vw;
        right: 5vw;
        max-height: 80vh;
    }
    
    .current-player-display {
        font-size: 16px;
        padding: 8px;
    }
    
    .join-race-btn {
        padding: 10px;
        font-size: 12px;
    }
    
    .file-upload-btn {
        padding: 6px 12px;
        font-size: 11px;
    }
}

/* ===== ASSET BROWSER PANEL ===== */
.ui-panel.asset-browser {
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 700px;
    max-width: 90vw;
    max-height: 85vh;
    overflow: hidden;
}

.asset-browser-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 600px;
}

.browser-toolbar {
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
    padding-bottom: 12px;
    margin-bottom: 12px;
}

.category-tabs {
    display: flex;
    gap: 4px;
    margin-bottom: 12px;
    overflow-x: auto;
    padding-bottom: 4px;
}

.category-tab {
    background: rgba(0, 255, 0, 0.1);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 6px 10px;
    font-family: inherit;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    flex-shrink: 0;
}

.category-tab:hover {
    background: rgba(0, 255, 0, 0.2);
    border-color: #00ff00;
}

.category-tab.active {
    background: rgba(255, 255, 0, 0.2);
    border-color: #ffff00;
    color: #ffff00;
    font-weight: bold;
}

.tab-icon {
    font-size: 14px;
}

.tab-name {
    font-size: 10px;
}

.search-section {
    display: flex;
    align-items: center;
    gap: 4px;
}

.search-input {
    flex: 1;
    background: #000;
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 3px;
    padding: 6px 8px;
    font-family: inherit;
    font-size: 12px;
}

.search-input:focus {
    outline: none;
    border-color: #00ff00;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);
}

.search-clear-btn {
    background: rgba(255, 0, 0, 0.2);
    color: #ff6666;
    border: 1px solid rgba(255, 0, 0, 0.4);
    border-radius: 3px;
    padding: 6px 8px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
}

.search-clear-btn:hover {
    background: rgba(255, 0, 0, 0.3);
    border-color: #ff0000;
}

.asset-grid-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
}

.category-info {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px;
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    margin-bottom: 8px;
}

.category-header {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: bold;
    color: #00ff00;
}

.category-icon {
    font-size: 16px;
}

.asset-count {
    font-size: 11px;
    color: #888;
}

.asset-grid {
    flex: 1;
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 8px;
    overflow-y: auto;
    padding: 8px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    max-height: 300px;
}

.asset-item {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
    display: flex;
    flex-direction: column;
    gap: 4px;
}

.asset-item:hover {
    border-color: #ffff00;
    box-shadow: 0 0 10px rgba(255, 255, 0, 0.2);
    transform: translateY(-1px);
}

.asset-item.selected {
    border-color: #ffff00;
    border-width: 2px;
    background: rgba(255, 255, 0, 0.1);
    box-shadow: 0 0 15px rgba(255, 255, 0, 0.3);
}

.asset-item.dragging {
    opacity: 0.7;
    transform: scale(0.95);
}

.asset-item.error {
    border-color: rgba(255, 0, 0, 0.5);
    background: rgba(255, 0, 0, 0.05);
}

.asset-thumbnail {
    width: 100%;
    height: 64px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #111;
    border-radius: 3px;
    overflow: hidden;
}

.thumbnail-canvas {
    max-width: 100%;
    max-height: 100%;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

.error-thumbnail {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 0, 0, 0.1);
    color: #ff6666;
}

.error-thumbnail .error-icon {
    font-size: 24px;
}

.asset-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.asset-name {
    font-size: 11px;
    font-weight: bold;
    color: #fff;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.asset-meta {
    font-size: 9px;
    color: #888;
}

.asset-dimensions {
    color: #00ff00;
}

.error-text {
    color: #ff6666;
}

.asset-actions {
    display: flex;
    gap: 2px;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.asset-item:hover .asset-actions {
    opacity: 1;
}

.asset-action-btn {
    background: rgba(0, 0, 0, 0.8);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 2px;
    padding: 2px 4px;
    cursor: pointer;
    font-size: 10px;
    transition: all 0.2s ease;
    flex: 1;
}

.asset-action-btn:hover {
    background: rgba(0, 255, 0, 0.2);
    border-color: #00ff00;
}

.asset-actions .apply-btn:hover {
    background: rgba(0, 255, 0, 0.3);
    color: #000;
}

.asset-actions .retry-btn {
    color: #ffaa00;
    border-color: rgba(255, 170, 0, 0.5);
}

.asset-actions .retry-btn:hover {
    background: rgba(255, 170, 0, 0.2);
    border-color: #ffaa00;
}

.loading-placeholder,
.empty-placeholder,
.error-placeholder {
    grid-column: 1 / -1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    padding: 40px 20px;
    color: #888;
    text-align: center;
}

.loading-spinner {
    width: 30px;
    height: 30px;
    border: 3px solid rgba(0, 255, 0, 0.3);
    border-top: none;
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

.empty-icon,
.error-icon {
    font-size: 48px;
    opacity: 0.5;
}

.empty-text,
.error-text,
.loading-text {
    font-size: 14px;
    font-weight: bold;
    color: #666;
}

.empty-subtitle {
    font-size: 12px;
    color: #555;
}

.retry-btn {
    background: rgba(0, 255, 0, 0.2);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 4px;
    padding: 6px 12px;
    font-family: inherit;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.retry-btn:hover {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
}

.asset-preview-section {
    border-top: 1px solid rgba(0, 255, 0, 0.3);
    padding-top: 12px;
    margin-top: 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    padding: 12px;
}

.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}

.preview-title {
    font-size: 12px;
    font-weight: bold;
    color: #00ff00;
    text-transform: uppercase;
}

.preview-close-btn {
    background: rgba(255, 0, 0, 0.2);
    color: #ff6666;
    border: 1px solid rgba(255, 0, 0, 0.4);
    border-radius: 3px;
    padding: 4px 6px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
}

.preview-close-btn:hover {
    background: rgba(255, 0, 0, 0.3);
    border-color: #ff0000;
}

.preview-content {
    display: grid;
    grid-template-columns: auto 1fr auto;
    gap: 12px;
    align-items: center;
}

.preview-canvas-container {
    width: 128px;
    height: 128px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #111;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
}

.preview-canvas {
    max-width: 100%;
    max-height: 100%;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

.asset-details {
    display: flex;
    flex-direction: column;
    gap: 6px;
    font-size: 11px;
}

.preview-actions {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.preview-actions .action-btn {
    padding: 8px 12px;
    font-size: 11px;
    border-radius: 4px;
    min-width: 120px;
}

.apply-btn {
    background: rgba(0, 255, 0, 0.2);
    border: 1px solid rgba(0, 255, 0, 0.5);
    color: #00ff00;
}

.apply-btn:hover:not(:disabled) {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
}

.export-btn {
    background: rgba(0, 150, 255, 0.2);
    border: 1px solid rgba(0, 150, 255, 0.5);
    color: #0096ff;
}

.export-btn:hover:not(:disabled) {
    background: rgba(0, 150, 255, 0.3);
    border-color: #0096ff;
}

.upload-section {
    border-top: 1px solid rgba(0, 255, 0, 0.3);
    padding-top: 12px;
    margin-top: 12px;
}

.upload-area {
    border: 2px dashed rgba(0, 255, 0, 0.3);
    border-radius: 6px;
    padding: 20px;
    text-align: center;
    cursor: pointer;
    transition: all 0.3s ease;
    background: rgba(0, 255, 0, 0.02);
    margin-bottom: 8px;
}

.upload-area:hover {
    border-color: #00ff00;
    background: rgba(0, 255, 0, 0.05);
}

.upload-area.drag-over {
    border-color: #ffff00;
    background: rgba(255, 255, 0, 0.1);
    border-style: solid;
}

.upload-area.uploading {
    opacity: 0.7;
    pointer-events: none;
}

.upload-icon {
    font-size: 32px;
    margin-bottom: 8px;
    color: #00ff00;
}

.upload-title {
    font-size: 14px;
    font-weight: bold;
    color: #00ff00;
    margin-bottom: 4px;
}

.upload-subtitle {
    font-size: 12px;
    color: #888;
}

.upload-hints {
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.upload-hints .hint-item {
    font-size: 10px;
    color: #666;
    text-align: center;
}

.refresh-btn {
    background: rgba(0, 150, 255, 0.2);
    color: #66ccff;
    border: 1px solid rgba(0, 150, 255, 0.4);
}

.refresh-btn:hover {
    background: rgba(0, 150, 255, 0.3);
    border-color: #0096ff;
    color: #0096ff;
}

/* Asset browser notification */
#asset-browser-notification {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    padding: 8px;
    border-radius: 4px;
    font-size: 11px;
    text-align: center;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
    pointer-events: none;
}

#asset-browser-notification.show {
    opacity: 1;
    transform: translateY(0);
}

#asset-browser-notification.success {
    background: rgba(0, 255, 0, 0.2);
    border: 1px solid #00ff00;
    color: #00ff00;
}

#asset-browser-notification.error {
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid #ff0000;
    color: #ff6666;
}

#asset-browser-notification.info {
    background: rgba(0, 150, 255, 0.2);
    border: 1px solid #0096ff;
    color: #66ccff;
}

/* Responsive adjustments for asset browser */
@media (max-width: 768px) {
    .ui-panel.asset-browser {
        width: 95vw;
        left: 2.5vw;
        transform: none;
        max-height: 90vh;
    }
    
    .asset-grid {
        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
        gap: 6px;
        max-height: 250px;
    }
    
    .category-tabs {
        gap: 2px;
    }
    
    .category-tab {
        padding: 4px 6px;
        font-size: 10px;
    }
    
    .tab-name {
        display: none;
    }
    
    .preview-content {
        grid-template-columns: 1fr;
        gap: 8px;
    }
    
    .preview-canvas-container {
        width: 100px;
        height: 100px;
        margin: 0 auto;
    }
    
    .preview-actions {
        flex-direction: row;
        justify-content: center;
    }
    
    .preview-actions .action-btn {
        min-width: auto;
        flex: 1;
    }
}

@media (max-width: 480px) {
    .ui-panel.asset-browser {
        width: 100vw;
        left: 0;
        top: 0;
        max-height: 100vh;
        border-radius: 0;
    }
    
    .asset-grid {
        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
        max-height: 200px;
    }
    
    .asset-item {
        padding: 4px;
    }
    
    .asset-thumbnail {
        height: 48px;
    }
    
    .asset-name {
        font-size: 10px;
    }
    
    .asset-meta {
        font-size: 8px;
    }
    
    .upload-area {
        padding: 15px;
    }
    
    .upload-icon {
        font-size: 24px;
    }
}

/* ===== PRESET MANAGER PANEL ===== */
.ui-panel.preset-manager {
    top: 20px;
    left: 50%;
    transform: translateX(-50%);
    width: 650px;
    max-width: 90vw;
    max-height: 85vh;
    overflow: hidden;
}

.preset-manager-content {
    display: flex;
    flex-direction: column;
    height: 100%;
    max-height: 600px;
    gap: 12px;
}

/* Category tabs */
.preset-categories {
    display: flex;
    gap: 4px;
    margin-bottom: 8px;
    overflow-x: auto;
    padding-bottom: 4px;
}

.category-tab {
    background: rgba(0, 255, 0, 0.1);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 6px 10px;
    font-family: inherit;
    font-size: 11px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    gap: 4px;
    white-space: nowrap;
    flex-shrink: 0;
}

.category-tab:hover {
    background: rgba(0, 255, 0, 0.2);
    border-color: #00ff00;
}

.category-tab.active {
    background: rgba(255, 255, 0, 0.2);
    border-color: #ffff00;
    color: #ffff00;
    font-weight: bold;
}

.tab-icon {
    font-size: 14px;
}

.tab-name {
    font-size: 10px;
}

/* Category info */
.current-category-info {
    padding: 8px;
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    margin-bottom: 8px;
}

.category-header {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 14px;
    font-weight: bold;
    color: #00ff00;
    margin-bottom: 4px;
}

.category-icon {
    font-size: 16px;
}

.category-description {
    font-size: 11px;
    color: #ccc;
    margin-bottom: 6px;
}

.category-stats {
    display: flex;
    gap: 12px;
    font-size: 10px;
    color: #888;
}

.preset-count {
    color: #00ff00;
}

.config-types {
    color: #ffaa00;
}

/* Preset list */
.preset-list-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 12px;
}

.preset-list {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 6px;
    overflow-y: auto;
    padding: 8px;
    background: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    max-height: 250px;
}

.preset-item {
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    padding: 8px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.preset-item:hover {
    border-color: #ffff00;
    box-shadow: 0 0 10px rgba(255, 255, 0, 0.2);
    transform: translateY(-1px);
}

.preset-item.selected {
    border-color: #ffff00;
    border-width: 2px;
    background: rgba(255, 255, 0, 0.1);
    box-shadow: 0 0 15px rgba(255, 255, 0, 0.3);
}

.preset-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 4px;
}

.preset-icon {
    font-size: 16px;
    color: #00ff00;
    width: 20px;
    text-align: center;
    flex-shrink: 0;
}

.preset-info {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 2px;
}

.preset-name {
    font-size: 12px;
    font-weight: bold;
    color: #fff;
}

.preset-meta {
    display: flex;
    gap: 8px;
    font-size: 10px;
    color: #888;
}

.preset-author {
    color: #00ff00;
}

.preset-date {
    color: #aaa;
}

.preset-actions {
    display: flex;
    gap: 2px;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.preset-item:hover .preset-actions {
    opacity: 1;
}

.preset-action-btn {
    background: rgba(0, 0, 0, 0.8);
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 2px;
    padding: 2px 4px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
    min-width: 24px;
    text-align: center;
}

.preset-action-btn:hover {
    background: rgba(0, 255, 0, 0.2);
    border-color: #00ff00;
}

.preset-action-btn.delete-btn:hover {
    background: rgba(255, 0, 0, 0.2);
    border-color: #ff0000;
    color: #ff6666;
}

.preset-description {
    font-size: 11px;
    color: #ccc;
    margin-bottom: 4px;
    line-height: 1.3;
}

.preset-tags {
    display: flex;
    gap: 4px;
    flex-wrap: wrap;
}

.preset-tag {
    background: rgba(0, 150, 255, 0.2);
    color: #66ccff;
    border: 1px solid rgba(0, 150, 255, 0.4);
    border-radius: 8px;
    padding: 1px 6px;
    font-size: 9px;
    font-weight: bold;
}

/* Empty state */
.empty-preset-list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    padding: 40px 20px;
    color: #666;
    text-align: center;
    min-height: 150px;
}

.empty-icon {
    font-size: 48px;
    opacity: 0.5;
}

.empty-text {
    font-size: 14px;
    font-weight: bold;
    color: #888;
}

.empty-subtitle {
    font-size: 12px;
    color: #666;
}

/* Action buttons */
.preset-actions {
    display: flex;
    flex-direction: column;
    gap: 8px;
}

.action-group {
    display: flex;
    gap: 6px;
}

.quick-actions .action-btn {
    flex: 1;
}

.file-actions .action-btn {
    flex: 1;
}

.create-btn {
    background: rgba(0, 255, 0, 0.2);
    border: 1px solid rgba(0, 255, 0, 0.5);
    color: #00ff00;
}

.create-btn:hover:not(:disabled) {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
}

.save-btn {
    background: rgba(0, 150, 255, 0.2);
    border: 1px solid rgba(0, 150, 255, 0.5);
    color: #0096ff;
}

.save-btn:hover:not(:disabled) {
    background: rgba(0, 150, 255, 0.3);
    border-color: #0096ff;
}

.load-btn {
    background: rgba(255, 165, 0, 0.2);
    border: 1px solid rgba(255, 165, 0, 0.5);
    color: #ffa500;
}

.load-btn:hover:not(:disabled) {
    background: rgba(255, 165, 0, 0.3);
    border-color: #ffa500;
}

.import-btn {
    background: rgba(128, 0, 128, 0.2);
    border: 1px solid rgba(128, 0, 128, 0.5);
    color: #bb88bb;
}

.import-btn:hover:not(:disabled) {
    background: rgba(128, 0, 128, 0.3);
    border-color: #aa77aa;
}

.export-btn {
    background: rgba(255, 20, 147, 0.2);
    border: 1px solid rgba(255, 20, 147, 0.5);
    color: #ff69b4;
}

.export-btn:hover:not(:disabled) {
    background: rgba(255, 20, 147, 0.3);
    border-color: #ff1493;
}

/* Preview section */
.preset-preview-section {
    border-top: 1px solid rgba(0, 255, 0, 0.3);
    padding-top: 12px;
    margin-top: 12px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 4px;
    padding: 12px;
}

.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 8px;
}

.preview-title {
    font-size: 12px;
    font-weight: bold;
    color: #00ff00;
    text-transform: uppercase;
}

.preview-close-btn {
    background: rgba(255, 0, 0, 0.2);
    color: #ff6666;
    border: 1px solid rgba(255, 0, 0, 0.4);
    border-radius: 3px;
    padding: 4px 6px;
    cursor: pointer;
    font-size: 12px;
    transition: all 0.2s ease;
}

.preview-close-btn:hover {
    background: rgba(255, 0, 0, 0.3);
    border-color: #ff0000;
}

.preview-preset-info h4 {
    color: #00ff00;
    margin: 0 0 4px 0;
    font-size: 14px;
}

.preview-description {
    color: #ccc;
    font-size: 11px;
    margin: 0 0 6px 0;
}

.preview-meta {
    display: flex;
    gap: 12px;
    font-size: 10px;
    margin-bottom: 8px;
}

.preview-author {
    color: #00ff00;
}

.preview-date {
    color: #888;
}

.preview-config-summary h5 {
    color: #ffff00;
    margin: 0 0 6px 0;
    font-size: 12px;
}

.config-items {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 8px;
}

.config-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px;
    background: rgba(0, 0, 0, 0.3);
    border-radius: 3px;
    font-size: 10px;
}

.config-type {
    color: #00ff00;
    font-weight: bold;
}

.config-changes {
    color: #888;
}

.no-config {
    color: #666;
    font-style: italic;
    text-align: center;
    padding: 8px;
}

.preview-actions {
    display: flex;
    justify-content: center;
}

.apply-btn {
    background: rgba(0, 255, 0, 0.3);
    border: 2px solid #00ff00;
    color: #00ff00;
    padding: 8px 16px;
    border-radius: 4px;
    font-weight: bold;
}

.apply-btn:hover {
    background: #00ff00;
    color: #000;
}

/* Create preset modal */
.preset-creation-modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2000;
    pointer-events: auto;
}

.preset-creation-modal .modal-content {
    background: #000;
    border: none;
    border-radius: 8px;
    max-width: 500px;
    width: 90vw;
    max-height: 80vh;
    overflow-y: auto;
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);
}

.preset-creation-modal .modal-header {
    background: #00ff00;
    color: #000;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: none;
}

.preset-creation-modal .modal-header h3 {
    margin: 0;
    font-size: 16px;
    font-weight: bold;
}

.preset-creation-modal .modal-body {
    padding: 20px;
    color: #00ff00;
}

.form-group {
    margin-bottom: 16px;
}

.form-group label {
    display: block;
    font-size: 12px;
    font-weight: bold;
    margin-bottom: 4px;
    color: #00ff00;
}

.form-input,
.form-textarea {
    width: 100%;
    background: #000;
    color: #00ff00;
    border: 1px solid rgba(0, 255, 0, 0.5);
    border-radius: 3px;
    padding: 6px 8px;
    font-family: inherit;
    font-size: 12px;
    resize: vertical;
}

.form-input:focus,
.form-textarea:focus {
    outline: none;
    border-color: #00ff00;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);
}

.config-source-options {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.radio-option {
    display: flex;
    align-items: center;
    gap: 6px;
    cursor: pointer;
    font-size: 11px;
}

.radio-option input[type="radio"] {
    accent-color: #00ff00;
}

.modal-actions {
    display: flex;
    gap: 8px;
    justify-content: flex-end;
    padding: 16px 20px;
    border-top: 1px solid rgba(0, 255, 0, 0.3);
}

.modal-actions .action-btn {
    padding: 8px 16px;
    font-size: 12px;
    border-radius: 4px;
    min-width: 80px;
}

.cancel-btn {
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid rgba(255, 0, 0, 0.5);
    color: #ff6666;
}

.cancel-btn:hover {
    background: rgba(255, 0, 0, 0.3);
    border-color: #ff0000;
}

.confirm-btn {
    background: rgba(0, 255, 0, 0.2);
    border: 1px solid rgba(0, 255, 0, 0.5);
    color: #00ff00;
}

.confirm-btn:hover {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
}

/* Preset manager notification */
#preset-manager-notification {
    position: absolute;
    bottom: 10px;
    left: 10px;
    right: 10px;
    padding: 8px;
    border-radius: 4px;
    font-size: 11px;
    text-align: center;
    opacity: 0;
    transform: translateY(10px);
    transition: all 0.3s ease;
    pointer-events: none;
}

#preset-manager-notification.show {
    opacity: 1;
    transform: translateY(0);
}

#preset-manager-notification.success {
    background: rgba(0, 255, 0, 0.2);
    border: 1px solid #00ff00;
    color: #00ff00;
}

#preset-manager-notification.error {
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid #ff0000;
    color: #ff6666;
}

#preset-manager-notification.info {
    background: rgba(0, 150, 255, 0.2);
    border: 1px solid #0096ff;
    color: #66ccff;
}

/* Responsive adjustments for preset manager */
@media (max-width: 768px) {
    .ui-panel.preset-manager {
        width: 95vw;
        left: 2.5vw;
        transform: none;
        max-height: 90vh;
    }
    
    .category-tabs {
        gap: 2px;
    }
    
    .category-tab {
        padding: 4px 6px;
        font-size: 10px;
    }
    
    .tab-name {
        display: none;
    }
    
    .action-group {
        flex-direction: column;
    }
    
    .action-group .action-btn {
        width: 100%;
    }
    
    .preset-list {
        max-height: 200px;
    }
}

@media (max-width: 480px) {
    .ui-panel.preset-manager {
        width: 100vw;
        left: 0;
        top: 0;
        max-height: 100vh;
        border-radius: 0;
    }
    
    .preset-manager-content {
        max-height: calc(100vh - 60px);
    }
    
    .preset-list {
        max-height: 150px;
    }
    
    .preset-item {
        padding: 6px;
    }
    
    .preset-meta {
        flex-direction: column;
        gap: 2px;
    }
    
    .preset-creation-modal .modal-content {
        width: 95vw;
        margin: 10px;
    }
    
    .modal-actions {
        flex-direction: column;
    }
    
    .modal-actions .action-btn {
        width: 100%;
    }
}

/* ===== PREVIEW SYSTEM STYLES ===== */
.ui-panel.preview-panel {
    top: 20px;
    right: 20px;
    width: 850px;
    max-width: calc(100vw - 40px);
    max-height: calc(100vh - 40px);
    min-height: 600px;
}

.preview-content {
    padding: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

/* Preview Controls */
.preview-controls {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    align-items: center;
    padding: 12px;
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
}

.mode-controls,
.comparison-controls {
    display: flex;
    align-items: center;
    gap: 8px;
}

.control-label {
    font-size: 12px;
    font-weight: bold;
    color: #00ff00;
    white-space: nowrap;
}

.control-select {
    background: #000;
    border: 1px solid #00ff00;
    color: #00ff00;
    padding: 4px 8px;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    border-radius: 2px;
}

.control-select:focus {
    outline: none;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.5);
}

.playback-controls {
    display: flex;
    align-items: center;
    gap: 12px;
}

.control-btn {
    background: rgba(0, 255, 0, 0.1);
    border: 1px solid #00ff00;
    color: #00ff00;
    padding: 6px 12px;
    font-family: 'Courier New', monospace;
    font-size: 11px;
    font-weight: bold;
    border-radius: 2px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 4px;
    transition: all 0.2s ease;
}

.control-btn:hover {
    background: rgba(0, 255, 0, 0.2);
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);
}

.control-btn:active {
    background: rgba(0, 255, 0, 0.3);
}

.control-btn .btn-icon {
    font-size: 12px;
}

.speed-control {
    display: flex;
    flex-direction: column;
    gap: 4px;
    min-width: 120px;
}

.speed-control label {
    font-size: 10px;
    color: #00ff00;
    font-weight: bold;
}

.speed-control input[type="range"] {
    width: 100%;
    height: 4px;
    background: rgba(0, 255, 0, 0.2);
    border-radius: 2px;
    outline: none;
    appearance: none;
}

.speed-control input[type="range"]::-webkit-slider-thumb {
    appearance: none;
    width: 12px;
    height: 12px;
    background: #00ff00;
    border-radius: 50%;
    cursor: pointer;
}

/* Preview Status */
.preview-status {
    display: flex;
    align-items: center;
    gap: 8px;
}

.status-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    border: 1px solid #00ff00;
}

.status-indicator.active {
    background: #00ff00;
    box-shadow: 0 0 8px rgba(0, 255, 0, 0.6);
    animation: pulse 1.5s ease-in-out infinite alternate;
}

.status-indicator.inactive {
    background: transparent;
}

.status-text {
    font-size: 12px;
    font-weight: bold;
}

@keyframes pulse {
    from { opacity: 1; }
    to { opacity: 0.4; }
}

/* Preview Container */
.preview-container {
    flex: 1;
    min-height: 300px;
    border: 2px solid rgba(0, 255, 0, 0.3);
    border-radius: 4px;
    overflow: hidden;
}

.preview-viewport {
    width: 100%;
    height: 100%;
    display: flex;
    position: relative;
}

.preview-viewport.split-screen {
    flex-direction: row;
}

.preview-viewport.picture-in-picture {
    flex-direction: column;
}

.preview-viewport.overlay {
    position: relative;
}

/* Preview Panes */
.preview-pane {
    display: flex;
    flex-direction: column;
    background: #000;
    border: 1px solid rgba(0, 255, 0, 0.2);
}

.preview-viewport.split-screen .preview-pane {
    flex: 1;
}

.preview-viewport.picture-in-picture .before-pane {
    flex: 2;
}

.preview-viewport.picture-in-picture .after-pane {
    flex: 1;
    position: absolute;
    bottom: 10px;
    right: 10px;
    width: 200px;
    height: 150px;
    border: 2px solid #00ff00;
    z-index: 10;
}

.preview-viewport.overlay .after-pane {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    opacity: 0.7;
}

.pane-header {
    background: rgba(0, 255, 0, 0.1);
    padding: 6px 12px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.pane-title {
    font-size: 11px;
    font-weight: bold;
    color: #00ff00;
}

.pane-info {
    font-size: 10px;
    color: rgba(0, 255, 0, 0.7);
}

.pane-content {
    flex: 1;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
}

.preview-canvas {
    border: none;
    background: #000;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

.preview-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.3);
    color: rgba(0, 255, 0, 0.5);
    font-size: 12px;
    font-weight: bold;
    pointer-events: none;
    transition: opacity 0.3s ease;
}

.preview-overlay.hidden {
    opacity: 0;
}

/* Preview Details */
.preview-details {
    display: flex;
    gap: 16px;
    max-height: 200px;
    overflow-y: auto;
}

.details-section {
    flex: 1;
    background: rgba(0, 255, 0, 0.05);
    border: 1px solid rgba(0, 255, 0, 0.2);
    border-radius: 4px;
    padding: 12px;
}

.section-title {
    font-size: 12px;
    font-weight: bold;
    color: #00ff00;
    margin: 0 0 8px 0;
    padding-bottom: 4px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
}

.info-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}

.info-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 4px 0;
}

.info-label {
    font-size: 10px;
    font-weight: bold;
    color: rgba(0, 255, 0, 0.8);
}

.info-value {
    font-size: 10px;
    color: #00ff00;
    text-align: right;
}

/* Change Log */
.change-log {
    max-height: 150px;
    overflow-y: auto;
    border: 1px solid rgba(0, 255, 0, 0.1);
    border-radius: 2px;
}

.log-entry {
    display: flex;
    gap: 8px;
    padding: 4px 8px;
    border-bottom: 1px solid rgba(0, 255, 0, 0.1);
    font-size: 10px;
}

.log-entry:last-child {
    border-bottom: none;
}

.log-entry.error {
    background: rgba(255, 0, 0, 0.1);
    color: #ff6666;
}

.log-entry.warning {
    background: rgba(255, 255, 0, 0.1);
    color: #ffff66;
}

.log-time {
    color: rgba(0, 255, 0, 0.6);
    font-weight: normal;
    white-space: nowrap;
    min-width: 60px;
}

.log-message {
    color: #00ff00;
    flex: 1;
}

/* Comparison Mode Adjustments */
.preview-viewport.comparison-side-by-side .preview-pane {
    border-right: 2px solid #00ff00;
}

.preview-viewport.comparison-side-by-side .preview-pane:last-child {
    border-right: none;
}

.preview-viewport.comparison-before-after .after-pane {
    transition: opacity 0.5s ease;
}

.preview-viewport.comparison-overlay .before-pane {
    opacity: 0.5;
}

/* Responsive Design */
@media (max-width: 1024px) {
    .ui-panel.preview-panel {
        width: calc(100vw - 20px);
        right: 10px;
        max-height: calc(100vh - 20px);
    }
    
    .preview-controls {
        flex-direction: column;
        align-items: stretch;
        gap: 12px;
    }
    
    .playback-controls {
        justify-content: space-between;
    }
    
    .info-grid {
        grid-template-columns: 1fr;
    }
    
    .preview-details {
        flex-direction: column;
    }
}

@media (max-width: 768px) {
    .preview-viewport.split-screen {
        flex-direction: column;
    }
    
    .preview-viewport.picture-in-picture .after-pane {
        position: relative;
        width: 100%;
        height: 200px;
        bottom: auto;
        right: auto;
    }
    
    .preview-canvas {
        width: 100%;
        height: auto;
        max-height: 200px;
    }
}

@media (max-width: 480px) {
    .ui-panel.preview-panel {
        width: 100vw;
        right: 0;
        top: 0;
        max-height: 100vh;
        border-radius: 0;
    }
    
    .preview-content {
        padding: 12px;
        gap: 12px;
    }
    
    .preview-controls {
        padding: 8px;
        gap: 8px;
    }
    
    .control-btn {
        padding: 4px 8px;
        font-size: 10px;
    }
    
    .preview-details {
        max-height: 150px;
    }
    
    .change-log {
        max-height: 100px;
    }
}

/* ===== TRACK EDITOR STYLES ===== */
.track-editor-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.95);
    z-index: 2000;
    display: flex;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);
}

.track-editor-container {
    width: 95vw;
    height: 95vh;
    background: rgba(0, 0, 0, 0.9);
    border: 2px solid #00ff00;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.4);
}

.track-editor-container.minimized .editor-sidebar {
    display: none;
}

.editor-header {
    background: #00ff00;
    color: #000;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 2px solid #00ff00;
}

.editor-title {
    display: flex;
    align-items: center;
    gap: 20px;
}

.title-text {
    font-size: 18px;
    font-weight: bold;
}

.editor-status {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    font-size: 12px;
}

.status-indicator {
    color: #666;
    font-size: 10px;
}

.track-info {
    font-weight: bold;
}

.editor-controls {
    display: flex;
    gap: 8px;
}

.editor-toolbar {
    background: rgba(0, 255, 0, 0.1);
    border-bottom: 1px solid rgba(0, 255, 0, 0.3);
    padding: 12px 16px;
    display: flex;
    gap: 24px;
    align-items: center;
    flex-wrap: wrap;
}

.tool-group {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.tool-group-label {
    font-size: 10px;
    color: #888;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.tool-palette {
    display: flex;
    gap: 4px;
}

.tool-btn {
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #333;
    color: #00ff00;
    padding: 8px 12px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    transition: all 0.2s ease;
    min-width: 60px;
}

.tool-btn:hover {
    border-color: #00ff00;
    background: rgba(0, 255, 0, 0.1);
}

.tool-btn.active {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
    color: #000;
}

.tool-icon {
    font-size: 16px;
}

.tool-name {
    font-size: 9px;
    text-transform: uppercase;
}

.brush-size-selector {
    display: flex;
    gap: 4px;
}

.brush-size-btn {
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #333;
    color: #00ff00;
    padding: 6px 10px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 11px;
    transition: all 0.2s ease;
    min-width: 40px;
}

.brush-size-btn:hover {
    border-color: #00ff00;
    background: rgba(0, 255, 0, 0.1);
}

.brush-size-btn.active {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
    color: #000;
}

.view-controls {
    display: flex;
    gap: 4px;
    align-items: center;
}

.zoom-level {
    font-size: 12px;
    color: #00ff00;
    min-width: 45px;
    text-align: center;
}

.action-controls {
    display: flex;
    gap: 4px;
}

.editor-main {
    flex: 1;
    display: flex;
    overflow: hidden;
}

.canvas-container {
    flex: 1;
    position: relative;
    background: #111;
    border-right: 1px solid rgba(0, 255, 0, 0.3);
    overflow: hidden;
}

.canvas-container.drag-over {
    background: rgba(0, 255, 0, 0.1);
    border: 2px dashed #00ff00;
}

.editor-canvas {
    display: block;
    max-width: 100%;
    max-height: 100%;
    cursor: crosshair;
    image-rendering: pixelated;
}

.canvas-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
}

.grid-overlay {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-image: 
        linear-gradient(rgba(0, 255, 0, 0.1) 1px, transparent 1px),
        linear-gradient(90deg, rgba(0, 255, 0, 0.1) 1px, transparent 1px);
    background-size: 50px 50px;
}

.crosshair {
    position: absolute;
    width: 20px;
    height: 20px;
    border: 1px solid #00ff00;
    transform: translate(-50%, -50%);
    pointer-events: none;
    opacity: 0.7;
}

.crosshair::before,
.crosshair::after {
    content: '';
    position: absolute;
    background: #00ff00;
}

.crosshair::before {
    top: 50%;
    left: 0;
    right: 0;
    height: 1px;
    transform: translateY(-50%);
}

.crosshair::after {
    left: 50%;
    top: 0;
    bottom: 0;
    width: 1px;
    transform: translateX(-50%);
}

.editor-sidebar {
    width: 280px;
    background: rgba(0, 0, 0, 0.9);
    border-left: 1px solid rgba(0, 255, 0, 0.3);
    display: flex;
    flex-direction: column;
    overflow-y: auto;
}

.sidebar-section {
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
}

.section-header {
    background: rgba(0, 255, 0, 0.1);
    padding: 8px 12px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid rgba(0, 255, 0, 0.2);
}

.section-title {
    font-size: 12px;
    font-weight: bold;
    color: #00ff00;
    text-transform: uppercase;
    letter-spacing: 1px;
}

.toggle-btn {
    background: none;
    border: none;
    color: #00ff00;
    cursor: pointer;
    font-size: 14px;
    padding: 2px;
}

.minimap-section {
    min-height: 150px;
}

.minimap-container {
    padding: 12px;
    position: relative;
}

.minimap-canvas {
    width: 100%;
    height: 100px;
    border: 1px solid #333;
    background: #000;
    image-rendering: pixelated;
}

.viewport-indicator {
    position: absolute;
    border: 2px solid #00ff00;
    background: rgba(0, 255, 0, 0.1);
    pointer-events: none;
}

.track-properties {
    padding: 12px;
}

.property-group {
    margin-bottom: 12px;
}

.property-label {
    display: block;
    font-size: 11px;
    color: #888;
    margin-bottom: 4px;
    text-transform: uppercase;
}

.property-input,
.property-select,
.property-textarea {
    width: 100%;
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #333;
    color: #00ff00;
    padding: 6px 8px;
    border-radius: 3px;
    font-family: inherit;
    font-size: 12px;
}

.property-input:focus,
.property-select:focus,
.property-textarea:focus {
    outline: none;
    border-color: #00ff00;
    background: rgba(0, 255, 0, 0.05);
}

.property-textarea {
    resize: vertical;
    min-height: 60px;
}

.editor-settings {
    padding: 12px;
}

.setting-group {
    margin-bottom: 8px;
}

.setting-checkbox {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 12px;
    color: #ccc;
}

.setting-checkbox input[type="checkbox"] {
    display: none;
}

.checkbox-custom {
    width: 16px;
    height: 16px;
    border: 1px solid #333;
    background: rgba(0, 0, 0, 0.8);
    border-radius: 2px;
    position: relative;
    transition: all 0.2s ease;
}

.setting-checkbox input[type="checkbox"]:checked + .checkbox-custom {
    background: rgba(0, 255, 0, 0.3);
    border-color: #00ff00;
}

.setting-checkbox input[type="checkbox"]:checked + .checkbox-custom::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: #00ff00;
    font-size: 12px;
    font-weight: bold;
}

.editor-footer {
    background: rgba(0, 255, 0, 0.1);
    border-top: 1px solid rgba(0, 255, 0, 0.3);
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;
}

.file-actions,
.preview-actions {
    display: flex;
    gap: 8px;
}

.action-btn {
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #333;
    color: #00ff00;
    padding: 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    transition: all 0.2s ease;
    text-transform: uppercase;
    font-weight: bold;
}

.action-btn:hover {
    border-color: #00ff00;
    background: rgba(0, 255, 0, 0.1);
    transform: translateY(-1px);
}

.action-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
}

.action-btn.primary-btn {
    background: rgba(0, 255, 0, 0.2);
    border-color: #00ff00;
}

.action-btn.primary-btn:hover {
    background: rgba(0, 255, 0, 0.4);
}

.preview-btn {
    background: rgba(0, 255, 255, 0.2);
    border-color: #00ffff;
    color: #00ffff;
}

.preview-btn:hover {
    background: rgba(0, 255, 255, 0.4);
}

.test-btn {
    background: rgba(255, 255, 0, 0.2);
    border-color: #ffff00;
    color: #ffff00;
}

.test-btn:hover {
    background: rgba(255, 255, 0, 0.4);
}

.btn-icon {
    font-size: 14px;
}

/* Track Editor Notifications */
#track-editor-notification {
    position: absolute;
    top: 20px;
    right: 20px;
    background: rgba(0, 0, 0, 0.9);
    border: 1px solid #333;
    border-radius: 4px;
    padding: 12px 16px;
    color: #00ff00;
    font-size: 12px;
    transform: translateX(100%);
    opacity: 0;
    transition: all 0.3s ease;
    z-index: 3000;
    max-width: 300px;
}

#track-editor-notification.show {
    transform: translateX(0);
    opacity: 1;
}

#track-editor-notification.success {
    border-color: #00ff00;
    color: #00ff00;
}

#track-editor-notification.error {
    border-color: #ff0000;
    color: #ff0000;
}

#track-editor-notification.warn {
    border-color: #ffff00;
    color: #ffff00;
}

#track-editor-notification.info {
    border-color: #00ffff;
    color: #00ffff;
}

/* Responsive Track Editor */
@media (max-width: 1200px) {
    .track-editor-container {
        width: 98vw;
        height: 98vh;
    }
    
    .editor-sidebar {
        width: 240px;
    }
    
    .editor-toolbar {
        flex-wrap: wrap;
        gap: 16px;
    }
    
    .tool-btn {
        min-width: 50px;
        padding: 6px 8px;
    }
    
    .tool-name {
        display: none;
    }
}

@media (max-width: 800px) {
    .track-editor-container {
        width: 100vw;
        height: 100vh;
        border-radius: 0;
    }
    
    .editor-toolbar {
        padding: 8px 12px;
        gap: 12px;
    }
    
    .tool-group {
        gap: 4px;
    }
    
    .editor-sidebar {
        width: 200px;
    }
    
    .editor-footer {
        flex-direction: column;
        gap: 12px;
    }
    
    .file-actions,
    .preview-actions {
        width: 100%;
        justify-content: center;
    }
}

/* ===== TRACK PREVIEW STYLES ===== */
.track-preview-panel {
    position: fixed;
    top: 50px;
    right: 50px;
    width: 80vw;
    height: 80vh;
    background: rgba(0, 0, 0, 0.95);
    border: none;
    border-radius: 8px;
    backdrop-filter: blur(10px);
    box-shadow: 0 0 30px rgba(0, 255, 0, 0.4);
    z-index: 2000;
    font-family: 'Courier New', monospace;
    color: #00ff00;
    overflow: hidden;
}

.preview-container {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.preview-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #00ff00;
    color: #000;
    padding: 12px 16px;
    border-bottom: 2px solid #00ff00;
}

.preview-title {
    display: flex;
    align-items: center;
    gap: 16px;
}

.preview-title .title-text {
    font-size: 18px;
    font-weight: bold;
}

.preview-status {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 12px;
}

.status-indicator {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #666;
}

.status-indicator.active {
    background: #ff0000;
    animation: pulse 1s infinite;
}

.status-indicator.inactive {
    background: #666;
}

@keyframes pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}

.fps-counter {
    font-family: 'Courier New', monospace;
    font-size: 11px;
    color: #000;
    background: rgba(255, 255, 255, 0.2);
    padding: 2px 6px;
    border-radius: 3px;
}

.preview-controls-header {
    display: flex;
    gap: 8px;
}

.preview-controls-header .control-btn {
    background: #000;
    color: #00ff00;
    border: 1px solid #00ff00;
    border-radius: 4px;
    padding: 6px 10px;
    cursor: pointer;
    font-family: 'Courier New', monospace;
    font-size: 12px;
    transition: all 0.2s;
}

.preview-controls-header .control-btn:hover {
    background: #00ff00;
    color: #000;
}

.preview-body {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 16px;
    gap: 16px;
    overflow: hidden;
}

.preview-main {
    display: flex;
    gap: 16px;
    flex: 1;
    min-height: 0;
}

.preview-viewport {
    flex: 1;
    position: relative;
    background: #000;
    border: 2px solid #00ff00;
    border-radius: 4px;
    overflow: hidden;
    min-height: 400px;
}

.preview-canvas,
.preview-overlay-canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    image-rendering: pixelated;
    image-rendering: -moz-crisp-edges;
    image-rendering: crisp-edges;
}

.preview-overlay-canvas {
    pointer-events: none;
    z-index: 1;
}

.preview-info-overlay {
    position: absolute;
    top: 8px;
    left: 8px;
    right: 8px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    pointer-events: none;
    z-index: 2;
}

.zoom-controls {
    display: flex;
    align-items: center;
    gap: 8px;
    background: rgba(0, 0, 0, 0.8);
    border: 1px solid #00ff00;
    border-radius: 4px;
    padding: 4px 8px;
    font-size: 12px;
    pointer-events: auto;
}

.zoom-btn {
    background: transparent;
    color: #00ff00;
    border: 1px solid #00ff00;
    border-radius: 2px;
    padding: 2px 6px;
    cursor: pointer;
    font-family: 'Courier New', monospace;
    font-size: 10px;
    transition: all 0.2s;
}

.zoom-btn:hover {
    background: #00ff00;
    color: #000;
}

.zoom-level {
    color: #00ff00;
    font-size: 10px;
    min-width: 30px;
    text-align: center;
}

.preview-sidebar {
    width: 300px;
    background: rgba(0, 20, 0, 0.8);
    border: 1px solid #00ff00;
    border-radius: 4px;
    padding: 16px;
    overflow-y: auto;
    max-height: 100%;
}

.sidebar-section {
    margin-bottom: 24px;
}

.sidebar-section:last-child {
    margin-bottom: 0;
}

.section-title {
    color: #00ff00;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 12px;
    border-bottom: 1px solid #00ff00;
    padding-bottom: 4px;
}

.settings-grid {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin-bottom: 16px;
}

.setting-item {
    display: flex;
    align-items: center;
    gap: 8px;
    cursor: pointer;
    font-size: 12px;
}

.setting-item input[type="checkbox"] {
    width: 14px;
    height: 14px;
    accent-color: #00ff00;
}

.setting-label {
    color: #00ff00;
    user-select: none;
}

.setting-group {
    margin-bottom: 12px;
}

.setting-group .setting-label {
    display: block;
    margin-bottom: 6px;
    font-size: 12px;
}

.setting-slider {
    width: 100%;
    accent-color: #00ff00;
    background: #333;
}

.validation-results,
.performance-metrics {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.validation-item,
.metric-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 11px;
    padding: 4px 0;
}

.validation-label,
.metric-label {
    color: #ccc;
}

.validation-status {
    font-weight: bold;
    text-transform: uppercase;
    font-size: 10px;
    padding: 2px 6px;
    border-radius: 2px;
}

.validation-status.valid {
    color: #00ff00;
    background: rgba(0, 255, 0, 0.2);
    border: 1px solid #00ff00;
}

.validation-status.invalid {
    color: #ff0000;
    background: rgba(255, 0, 0, 0.2);
    border: 1px solid #ff0000;
}

.validation-status.unknown {
    color: #ffff00;
    background: rgba(255, 255, 0, 0.2);
    border: 1px solid #ffff00;
}

.metric-value {
    color: #00ff00;
    font-weight: bold;
    font-family: 'Courier New', monospace;
}

/* Live Preview Button in Track Editor */
.live-preview-btn {
    background: linear-gradient(135deg, #000 0%, #003300 100%);
    border: 2px solid #00ff00;
    color: #00ff00;
    box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);
}

.live-preview-btn:hover {
    background: linear-gradient(135deg, #00ff00 0%, #00cc00 100%);
    color: #000;
    box-shadow: 0 0 15px rgba(0, 255, 0, 0.5);
}

/* Responsive Design for Track Preview */
@media (max-width: 1200px) {
    .track-preview-panel {
        width: 90vw;
        height: 85vh;
        top: 30px;
        right: 30px;
    }
    
    .preview-sidebar {
        width: 250px;
    }
    
    .preview-main {
        flex-direction: column;
    }
    
    .preview-viewport {
        min-height: 300px;
    }
}

@media (max-width: 800px) {
    .track-preview-panel {
        width: 95vw;
        height: 90vh;
        top: 20px;
        right: 20px;
    }
    
    .preview-main {
        flex-direction: column;
    }
    
    .preview-sidebar {
        width: 100%;
        max-height: 200px;
    }
    
    .preview-viewport {
        min-height: 200px;
    }
    
    .settings-grid {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 6px;
    }
    
    .section-title {
        font-size: 12px;
    }
    
    .setting-item {
        font-size: 11px;
    }
}`, "",{"version":3,"sources":["webpack://./src/ui/styles/game-ui.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF,kCAAkC;;AAGlC,gCAAgC;;AAGhC,4BAA4B;;AAG5B,4BAA4B;AAC5B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,oBAAoB;IACpB,aAAa;IACb,iEAAiE;IACjE,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,kBAAkB;IAClB,8BAA8B;IAC9B,YAAY,EAAE,0CAA0C;IACxD,kBAAkB;IAClB,oBAAoB;IACpB,0BAA0B;IAC1B,uCAAuC;IACvC,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,kCAAkC;AAClC,uEAAuE;AACvE,8EAA8E;AAC9E;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;CAsCC;AACD,mBAAmB,cAAc,EAAE;;AAEnC,8BAA8B;AAC9B;IACI,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,OAAO,YAAY,EAAE;IACrB,KAAK,UAAU,EAAE;AACrB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,8BAA8B;AAClC;;AAEA;IACI,OAAO;IACP,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;IAChB,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;;AAGA;IACI,aAAa;IACb,yCAAyC;IACzC,QAAQ;IACR,YAAY;IACZ,gCAAgC;IAChC,6CAA6C;IAC7C,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,yCAAyC;IACzC,QAAQ;IACR,gBAAgB;IAChB,6CAA6C;IAC7C,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,sCAAsC;AAC1C;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,eAAe;IACf,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;;AAGA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,0CAA0C;IAC1C,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,iCAAiC;IACjC,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,YAAY;AAChB;;AAEA,4BAA4B;AAC5B;IACI,YAAY;IACZ,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,wCAAwC;IACxC,kBAAkB;IAClB,YAAY;IACZ,mCAAmC;IACnC,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,OAAO;AACX;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,0BAA0B;IAC1B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,0BAA0B;IAC1B,kCAAkC;AACtC;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,kCAAkC;IAClC,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,eAAe;IACf,aAAa;AACjB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,iBAAiB;IACjB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;AAC5C;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,OAAO;AACX;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA,wCAAwC;AACxC;IACI,0BAA0B;AAC9B;;AAEA,0CAA0C;AAC1C;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,uCAAuC;AACvC;IACI;QACI,WAAW;QACX,SAAS;QACT,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,0BAA0B;IAC9B;AACJ;;AAEA;IACI;QACI,yBAAyB;QACzB,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,QAAQ;IACZ;;IAEA;QACI,kBAAkB;IACtB;;IAEA;;QAEI,WAAW;QACX,kBAAkB;IACtB;AACJ;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,WAAW;IACX,eAAe;IACf,eAAe;IACf,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,sCAAsC;IACtC,kBAAkB;IAClB,iCAAiC;AACrC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,OAAO;IACP,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;IAClB,oBAAoB;IACpB,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,oCAAoC;IACpC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,gCAAgC;IAChC,WAAW;IACX,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,yCAAyC;IACzC,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,oBAAoB;AACxB;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,2BAA2B;IAC3B,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,oBAAoB;IACpB,UAAU;IACV,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,UAAU;IACV,aAAa;AACjB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;AAClB;;AAEA,kCAAkC;AAClC;IACI;QACI,eAAe;IACnB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;QACnB,YAAY;QACZ,WAAW;IACf;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;QACT,UAAU;QACV,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,yBAAyB;IAC7B;;IAEA;QACI,SAAS;QACT,WAAW;QACX,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,YAAY;QACZ,UAAU;QACV,yBAAyB;QACzB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA,8BAA8B;AAC9B;IACI;QACI,qCAAqC;QACrC,uCAAuC;QACvC,sCAAsC;IAC1C;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;AACJ;;AAEA,yCAAyC;AACzC;;;;;;IAMI,0BAA0B;IAC1B,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI;QACI,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,qCAAqC;IACrC,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,2DAA2D;IAC3D,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,mBAAmB;IACnB,eAAe;IACf,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,0CAA0C;IAC1C,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,oBAAoB;IACpB,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;IACrB,cAAc;IACd,kCAAkC;AACtC;;AAEA,wCAAwC;AACxC;IACI;QACI,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,2DAA2D;QAC3D,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,eAAe;QACf,WAAW;IACf;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;IACb;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;QACR,kBAAkB;IACtB;AACJ;;AAEA,mCAAmC;AACnC;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,eAAe;IACf,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,2BAA2B;AAC/B;;AAEA;;IAEI,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,gCAAgC;IAChC,sCAAsC;IACtC,kBAAkB;IAClB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;;IAEI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;IAEI,eAAe;AACnB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,0BAA0B;AAC1B;IACI,qBAAqB;IACrB,2CAA2C;AAC/C;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;AACtC;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,cAAc;AAClB;;AAEA,4CAA4C;AAC5C;IACI;QACI,WAAW;QACX,UAAU;QACV,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;AACJ;;AAEA,oCAAoC;AACpC;IACI,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;IAC7C,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,OAAO;IACP,aAAa;IACb,4DAA4D;IAC5D,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,cAAc;IACd,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,OAAO;AACX;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;;;IAGI,mBAAmB;IACnB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,gBAAgB;IAChB,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;;IAEI,eAAe;IACf,YAAY;AAChB;;AAEA;;;IAGI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,uCAAuC;IACvC,kBAAkB;IAClB,aAAa;IACb,kBAAkB;IAClB,eAAe;IACf,yBAAyB;IACzB,iCAAiC;IACjC,kBAAkB;AACtB;;AAEA;IACI,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,kCAAkC;IAClC,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,wCAAwC;AAC5C;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;AAClB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,cAAc;AAClB;;AAEA,6CAA6C;AAC7C;IACI;QACI,WAAW;QACX,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,4DAA4D;QAC5D,QAAQ;QACR,iBAAiB;IACrB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,0BAA0B;QAC1B,QAAQ;IACZ;;IAEA;QACI,YAAY;QACZ,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,mBAAmB;QACnB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;QACf,OAAO;IACX;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,OAAO;QACP,MAAM;QACN,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,2DAA2D;QAC3D,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,qCAAqC;AACrC;IACI,SAAS;IACT,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,iBAAiB;IACjB,SAAS;AACb;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;IACjB,oBAAoB;IACpB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,kBAAkB;AAClB;IACI,YAAY;IACZ,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA,gBAAgB;AAChB;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;IAChB,YAAY;IACZ,8BAA8B;IAC9B,sCAAsC;IACtC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,2CAA2C;IAC3C,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,kCAAkC;IAClC,2CAA2C;AAC/C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,UAAU;IACV,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,kCAAkC;IAClC,cAAc;IACd,wCAAwC;IACxC,kBAAkB;IAClB,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;AACf;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,kCAAkC;IAClC,wCAAwC;IACxC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;AACzB;;AAEA;IACI,mCAAmC;IACnC,yCAAyC;IACzC,cAAc;AAClB;;AAEA;IACI,mCAAmC;IACnC,qBAAqB;AACzB;;AAEA,oBAAoB;AACpB;IACI,0CAA0C;IAC1C,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,8BAA8B;IAC9B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;AAClB;;AAEA;;IAEI,WAAW;IACX,gBAAgB;IAChB,cAAc;IACd,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,qBAAqB;IACrB,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,yBAAyB;IACzB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA,gCAAgC;AAChC;IACI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,2BAA2B;IAC3B,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,yBAAyB;IACzB,cAAc;AAClB;;AAEA,8CAA8C;AAC9C;IACI;QACI,WAAW;QACX,WAAW;QACX,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,OAAO;QACP,MAAM;QACN,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,sCAAsC;AACtC;IACI,SAAS;IACT,WAAW;IACX,YAAY;IACZ,6BAA6B;IAC7B,8BAA8B;IAC9B,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,qBAAqB;AACrB;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;IACnB,aAAa;IACb,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;;IAEI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,qCAAqC;IACrC,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,wCAAwC;AAC5C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,qCAAqC;IACrC,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;AAC5C;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,gCAAgC;IAChC,kBAAkB;IAClB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA,mBAAmB;AACnB;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,wCAAwC;IACxC,oDAAoD;AACxD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,OAAO,UAAU,EAAE;IACnB,KAAK,YAAY,EAAE;AACvB;;AAEA,sBAAsB;AACtB;IACI,OAAO;IACP,iBAAiB;IACjB,sCAAsC;IACtC,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;AACtB;;AAEA,kBAAkB;AAClB;IACI,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,sCAAsC;AAC1C;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,OAAO;AACX;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,6CAA6C;IAC7C,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,2BAA2B;IAC3B,eAAe;IACf,iBAAiB;IACjB,oBAAoB;IACpB,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,iBAAiB;IACjB,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;AACrB;;AAEA,eAAe;AACf;IACI,iBAAiB;IACjB,gBAAgB;IAChB,sCAAsC;IACtC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,gBAAgB;IAChB,6CAA6C;IAC7C,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gCAAgC;IAChC,cAAc;AAClB;;AAEA;IACI,kCAAkC;IAClC,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,mBAAmB;IACnB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,OAAO;AACX;;AAEA,gCAAgC;AAChC;IACI,+BAA+B;AACnC;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,YAAY;AAChB;;AAEA,sBAAsB;AACtB;IACI;QACI,yBAAyB;QACzB,WAAW;QACX,8BAA8B;IAClC;;IAEA;QACI,sBAAsB;QACtB,oBAAoB;QACpB,SAAS;IACb;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,sBAAsB;IAC1B;AACJ;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,aAAa;QACb,YAAY;QACZ,WAAW;IACf;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,QAAQ;QACR,MAAM;QACN,iBAAiB;QACjB,gBAAgB;IACpB;;IAEA;QACI,aAAa;QACb,SAAS;IACb;;IAEA;QACI,YAAY;QACZ,QAAQ;IACZ;;IAEA;QACI,gBAAgB;QAChB,eAAe;IACnB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA,oCAAoC;AACpC;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,YAAY;IACZ,aAAa;IACb,+BAA+B;IAC/B,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gCAAgC;IAChC,6CAA6C;IAC7C,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,eAAe;IACf,WAAW;IACX,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,QAAQ;IACR,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,eAAe;AACnB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,OAAO;IACP,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,4CAA4C;IAC5C,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ;;yEAEqE;IACrE,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,gCAAgC;IAChC,oBAAoB;IACpB,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,QAAQ;IACR,OAAO;IACP,QAAQ;IACR,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,SAAS;IACT,MAAM;IACN,SAAS;IACT,UAAU;IACV,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,8BAA8B;IAC9B,2CAA2C;IAC3C,aAAa;IACb,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,6CAA6C;AACjD;;AAEA;IACI,gCAAgC;IAChC,iBAAiB;IACjB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,6CAA6C;AACjD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,gBAAgB;IAChB,0BAA0B;AAC9B;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;IACzB,gCAAgC;IAChC,oBAAoB;AACxB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;;;IAGI,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,oBAAoB;IACpB,eAAe;AACnB;;AAEA;;;IAGI,aAAa;IACb,qBAAqB;IACrB,iCAAiC;AACrC;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,cAAc;IACd,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,0CAA0C;IAC1C,kBAAkB;IAClB,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,8BAA8B;IAC9B,sBAAsB;IACtB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,yBAAyB;IACzB,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;IAChC,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,kCAAkC;IAClC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,eAAe;AACnB;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,8BAA8B;IAC9B,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,cAAc;IACd,eAAe;IACf,2BAA2B;IAC3B,UAAU;IACV,yBAAyB;IACzB,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;IACxB,UAAU;AACd;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,aAAa;QACb,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;QACjB,SAAS;IACb;;IAEA;QACI,QAAQ;IACZ;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;;QAEI,WAAW;QACX,uBAAuB;IAC3B;AACJ;;AAEA,qCAAqC;AACrC;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,YAAY;IACZ,kBAAkB;IAClB,2BAA2B;IAC3B,yCAAyC;IACzC,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,mBAAmB;IACnB,WAAW;IACX,kBAAkB;IAClB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,WAAW;IACX,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,4BAA4B;AAChC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW,UAAU,EAAE;IACvB,MAAM,YAAY,EAAE;AACxB;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,WAAW;IACX,oCAAoC;IACpC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,QAAQ;AACZ;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,iBAAiB;IACjB,eAAe;IACf,qCAAqC;IACrC,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,OAAO;IACP,aAAa;IACb,sBAAsB;IACtB,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,OAAO;IACP,aAAa;AACjB;;AAEA;IACI,OAAO;IACP,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;;IAEI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,0BAA0B;IAC1B,iCAAiC;IACjC,4BAA4B;AAChC;;AAEA;IACI,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,UAAU;IACV,aAAa;IACb,8BAA8B;IAC9B,uBAAuB;IACvB,oBAAoB;IACpB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,8BAA8B;IAC9B,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,uBAAuB;IACvB,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,qCAAqC;IACrC,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;IACf,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,+BAA+B;IAC/B,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,iBAAiB;IACjB,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;;IAEI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,cAAc;AAClB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,yBAAyB;IACzB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,gCAAgC;IAChC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qCAAqC;AACzC;;AAEA,wCAAwC;AACxC;IACI,0DAA0D;IAC1D,yBAAyB;IACzB,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,6DAA6D;IAC7D,WAAW;IACX,yCAAyC;AAC7C;;AAEA,wCAAwC;AACxC;IACI;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,WAAW;IACf;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,WAAW;IACf;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;QACX,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;QACb,8BAA8B;QAC9B,QAAQ;IACZ;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":["/**\n * game-ui.css - Styling for Memex Racing UI Components\n * \n * Retro pixel art aesthetic with terminal green (#00ff00) on black backgrounds,\n * Courier New font, and responsive design for racing game interface.\n * Includes styles for Track Editor, Live Preview, and Analytics Panel components.\n */\n\n/* Import Analytics Panel Styles */\n@import url('./analytics-panel.css');\n\n/* Import Tournament UI Styles */\n@import url('./tournament-ui.css');\n\n/* Import Animation Styles */\n@import url('./animations.css');\n\n/* ===== BASE STYLES ===== */\n.ui-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    pointer-events: none;\n    z-index: 1000;\n    font-family: 'Courier New', 'Monaco', 'Lucida Console', monospace;\n    color: #00ff00;\n    font-size: 14px;\n    line-height: 1.4;\n}\n\n.ui-overlay * {\n    box-sizing: border-box;\n}\n\n/* ===== PANEL BASE STYLES ===== */\n.ui-panel {\n    position: absolute;\n    background: rgba(0, 0, 0, 0.9);\n    border: none; /* Removed green border per user request */\n    border-radius: 4px;\n    pointer-events: auto;\n    backdrop-filter: blur(5px);\n    box-shadow: 0 0 20px rgba(0, 0, 0, 0.3);\n    min-width: 200px;\n    max-width: 400px;\n}\n\n.ui-panel.hidden {\n    display: none !important;\n}\n\n.panel-header {\n    background: #00ff00;\n    color: #000;\n    padding: 8px 12px;\n    font-weight: bold;\n    font-size: 16px;\n    border-bottom: 2px solid #00ff00;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.panel-title {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.panel-body {\n    padding: 12px;\n    max-height: 400px;\n    overflow-y: auto;\n}\n\n.panel-body::-webkit-scrollbar {\n    width: 8px;\n}\n\n.panel-body::-webkit-scrollbar-track {\n    background: #000;\n}\n\n.panel-body::-webkit-scrollbar-thumb {\n    background: #00ff00;\n    border-radius: 4px;\n}\n\n/* ===== PLAYER INFO PANEL ===== */\n/* REMOVED - Player info panel was removed per changelog requirements */\n/* The panel is no longer created in UIManager.js so these styles are unused */\n/*\n.player-info {\n    top: 20px;\n    left: 20px;\n    width: 250px;\n}\n\n.player-details {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.detail-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 0;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.detail-row:last-child {\n    border-bottom: none;\n}\n\n.label {\n    font-weight: bold;\n    color: #00ff00;\n}\n\n.value {\n    color: #ffffff;\n}\n\n.status-menu { color: #00ff00; }\n.status-lobby { color: #ffff00; }\n.status-betting { color: #ff8800; }\n.status-racing { color: #ff0000; }\n*/\n.status-finished { color: #00ff00; }\n\n/* ===== BETTING PANEL ===== */\n.betting-panel {\n    bottom: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 600px;\n    max-width: 90vw;\n}\n\n.countdown-timer {\n    background: rgba(255, 0, 0, 0.2);\n    border: 1px solid #ff0000;\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-weight: bold;\n    color: #ff0000;\n}\n\n.countdown-timer.warning {\n    background: rgba(255, 255, 0, 0.2);\n    border-color: #ffff00;\n    color: #ffff00;\n}\n\n.countdown-timer.urgent {\n    background: rgba(255, 0, 0, 0.4);\n    border-color: #ff0000;\n    color: #ff0000;\n    animation: pulse 0.5s infinite alternate;\n}\n\n@keyframes pulse {\n    from { opacity: 0.7; }\n    to { opacity: 1; }\n}\n\n.betting-status {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 12px;\n    padding: 8px;\n    background: rgba(0, 255, 0, 0.1);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n}\n\n.balance-display, .current-bet-display {\n    display: flex;\n    gap: 8px;\n}\n\n.current-bet-display .value.has-bet {\n    color: #ffff00;\n    font-weight: bold;\n}\n\n.balance-display .value.low-balance {\n    color: #ff8800;\n}\n\n.balance-display .value.no-balance {\n    color: #ff0000;\n    font-weight: bold;\n}\n\n.players-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n    gap: 8px;\n    margin-bottom: 12px;\n}\n\n.player-card {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.player-card:hover {\n    background: rgba(0, 255, 0, 0.1);\n    border-color: #00ff00;\n    transform: translateY(-2px);\n}\n\n.player-card.selected {\n    background: rgba(255, 255, 0, 0.2);\n    border-color: #ffff00;\n    box-shadow: 0 0 10px rgba(255, 255, 0, 0.3);\n}\n\n.player-card .player-info {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 6px;\n}\n\n.player-avatar {\n    width: 24px;\n    height: 24px;\n    background: #00ff00;\n    color: #000;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: bold;\n    font-size: 12px;\n    flex-shrink: 0;\n}\n\n.player-details {\n    flex: 1;\n}\n\n.player-name {\n    font-weight: bold;\n    font-size: 12px;\n    display: block;\n}\n\n.player-stats {\n    font-size: 10px;\n    color: #aaa;\n    display: flex;\n    gap: 8px;\n}\n\n.betting-info {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 6px;\n    font-size: 11px;\n}\n\n.odds-display, .pool-display {\n    text-align: center;\n}\n\n.odds-label, .pool-label {\n    display: block;\n    color: #888;\n    font-size: 10px;\n}\n\n.odds-value {\n    color: #00ff00;\n    font-weight: bold;\n}\n\n.pool-value {\n    color: #ffff00;\n}\n\n.bet-button {\n    width: 100%;\n    background: #00ff00;\n    color: #000;\n    border: none;\n    border-radius: 4px;\n    padding: 6px;\n    font-family: inherit;\n    font-weight: bold;\n    font-size: 11px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.bet-button:hover:not(:disabled) {\n    background: #00cc00;\n    transform: scale(1.05);\n}\n\n.bet-button:disabled {\n    background: #333;\n    color: #666;\n    cursor: not-allowed;\n}\n\n.betting-controls {\n    margin-bottom: 12px;\n}\n\n.bet-amount-section {\n    margin-bottom: 8px;\n}\n\n.bet-amount-section label {\n    display: block;\n    margin-bottom: 4px;\n    font-weight: bold;\n}\n\n.slider-container {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n#bet-amount-slider {\n    width: 100%;\n    height: 6px;\n    background: #333;\n    outline: none;\n    border-radius: 3px;\n}\n\n#bet-amount-slider::-webkit-slider-thumb {\n    appearance: none;\n    width: 16px;\n    height: 16px;\n    background: #00ff00;\n    cursor: pointer;\n    border-radius: 50%;\n}\n\n#bet-amount-slider::-moz-range-thumb {\n    width: 16px;\n    height: 16px;\n    background: #00ff00;\n    cursor: pointer;\n    border-radius: 50%;\n    border: none;\n}\n\n.slider-presets {\n    display: flex;\n    gap: 4px;\n    justify-content: space-between;\n}\n\n.preset-btn {\n    flex: 1;\n    background: rgba(0, 255, 0, 0.2);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 4px;\n    padding: 4px;\n    font-family: inherit;\n    font-size: 10px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.preset-btn:hover {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n}\n\n.bet-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.action-btn {\n    flex: 1;\n    background: rgba(0, 255, 0, 0.2);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 4px;\n    padding: 8px;\n    font-family: inherit;\n    font-weight: bold;\n    font-size: 12px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n}\n\n.action-btn:hover:not(:disabled) {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n    transform: translateY(-1px);\n}\n\n.action-btn:disabled {\n    background: rgba(100, 100, 100, 0.1);\n    color: #666;\n    border-color: #333;\n    cursor: not-allowed;\n}\n\n.betting-stats {\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n    padding-top: 8px;\n    display: flex;\n    justify-content: space-between;\n}\n\n.stats-row {\n    display: flex;\n    gap: 8px;\n}\n\n.stat-label {\n    color: #888;\n    font-size: 11px;\n}\n\n.stat-value {\n    color: #00ff00;\n    font-weight: bold;\n    font-size: 11px;\n}\n\n.stat-value.has-potential {\n    color: #ffff00;\n}\n\n.panel-controls {\n    display: flex;\n    gap: 4px;\n}\n\n.control-btn {\n    background: #000;\n    color: #00ff00;\n    border: 1px solid #00ff00;\n    border-radius: 3px;\n    padding: 2px 6px;\n    cursor: pointer;\n    font-family: inherit;\n    font-size: 12px;\n}\n\n.control-btn:hover {\n    background: #00ff00;\n    color: #000;\n}\n\n.sort-controls, .time-filter {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 11px;\n}\n\n.sort-controls label, .time-filter label {\n    font-weight: bold;\n    color: #00ff00;\n    white-space: nowrap;\n}\n\n.sort-controls select, .time-filter select {\n    flex: 1;\n    background: #000;\n    color: #00ff00;\n    border: 1px solid #00ff00;\n    border-radius: 3px;\n    padding: 3px 6px;\n    font-family: inherit;\n    font-size: 11px;\n}\n\n.sort-order-btn {\n    background: #00ff00;\n    color: #000;\n    border: none;\n    border-radius: 3px;\n    padding: 3px 8px;\n    cursor: pointer;\n    font-family: inherit;\n    font-weight: bold;\n    font-size: 11px;\n}\n\n.sort-order-btn:hover {\n    background: #00cc00;\n}\n\n\n.table-header {\n    display: grid;\n    grid-template-columns: 50px 1fr 80px 60px;\n    gap: 8px;\n    padding: 8px;\n    background: rgba(0, 255, 0, 0.2);\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n    font-weight: bold;\n    font-size: 11px;\n}\n\n.table-body {\n    max-height: 300px;\n    overflow-y: auto;\n}\n\n.table-body.updating {\n    opacity: 0.7;\n    transition: opacity 0.3s ease;\n}\n\n.player-row {\n    display: grid;\n    grid-template-columns: 50px 1fr 80px 60px;\n    gap: 8px;\n    padding: 6px 8px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.1);\n    font-size: 10px;\n    transition: all 0.2s ease;\n}\n\n.player-row:hover {\n    background: rgba(0, 255, 0, 0.1);\n}\n\n.player-row.rank-1 {\n    background: rgba(255, 215, 0, 0.1);\n    border-color: rgba(255, 215, 0, 0.3);\n}\n\n.player-row.rank-2 {\n    background: rgba(192, 192, 192, 0.1);\n    border-color: rgba(192, 192, 192, 0.3);\n}\n\n.player-row.rank-3 {\n    background: rgba(205, 127, 50, 0.1);\n    border-color: rgba(205, 127, 50, 0.3);\n}\n\n.rank-col {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.rank-number {\n    font-weight: bold;\n    color: #00ff00;\n}\n\n.rank-medal {\n    font-size: 12px;\n}\n\n.player-col .player-info {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n}\n\n.player-col .player-avatar {\n    width: 16px;\n    height: 16px;\n    font-size: 10px;\n    flex-shrink: 0;\n}\n\n.player-details {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.player-name {\n    font-weight: bold;\n    color: #fff;\n    font-size: 10px;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.player-status {\n    font-size: 8px;\n    display: flex;\n    align-items: center;\n    gap: 2px;\n}\n\n.player-status.online {\n    color: #00ff00;\n}\n\n.player-status.offline {\n    color: #666;\n}\n\n.stats-col {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    font-size: 9px;\n}\n\n.stat-item {\n    display: flex;\n    justify-content: space-between;\n    gap: 4px;\n}\n\n.stat-label {\n    color: #888;\n}\n\n.stat-value.win-rate {\n    color: #ffff00;\n}\n\n.stat-value.wins {\n    color: #00ff00;\n}\n\n.score-col {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.score-value {\n    font-weight: bold;\n    color: #00ff00;\n    font-size: 11px;\n}\n\n.score-label {\n    color: #888;\n    font-size: 8px;\n}\n\n\n.summary-item {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 2px;\n}\n\n.summary-item .label {\n    color: #888;\n    font-size: 9px;\n}\n\n.summary-item .value {\n    color: #00ff00;\n    font-weight: bold;\n}\n\n.recent-winners {\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n    padding-top: 8px;\n}\n\n.section-header {\n    font-weight: bold;\n    color: #00ff00;\n    font-size: 11px;\n    margin-bottom: 6px;\n}\n\n.winners-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.winner-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 4px;\n    background: rgba(0, 255, 0, 0.05);\n    border-radius: 3px;\n    font-size: 10px;\n}\n\n.winner-avatar {\n    font-size: 12px;\n}\n\n.winner-name {\n    flex: 1;\n    color: #fff;\n    font-weight: bold;\n}\n\n.winner-time {\n    color: #888;\n    font-size: 9px;\n}\n\n.no-winners {\n    text-align: center;\n    color: #666;\n    font-style: italic;\n    font-size: 10px;\n    padding: 8px;\n}\n\n/* ===== DEBUG PANEL ===== */\n.debug-panel {\n    bottom: 20px;\n    left: 20px;\n    width: 350px;\n    max-height: 80vh;\n    overflow-y: auto;\n}\n\n.debug-content {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n.debug-section {\n    border: 1px solid rgba(255, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 8px;\n    background: rgba(255, 255, 0, 0.05);\n    position: relative;\n}\n\n.debug-section h4 {\n    color: #ffff00;\n    font-size: 12px;\n    margin: 0 0 8px 0;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.section-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.section-header h4 {\n    margin: 0;\n    flex: 1;\n}\n\n.section-header .toggle-btn {\n    background: rgba(255, 255, 0, 0.2);\n    border: 1px solid rgba(255, 255, 0, 0.4);\n    color: #ffff00;\n    font-size: 14px;\n    padding: 2px 6px;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.section-header .toggle-btn:hover {\n    background: rgba(255, 255, 0, 0.3);\n    border-color: #ffff00;\n}\n\n.section-header .clear-btn {\n    background: rgba(255, 0, 0, 0.2);\n    border: 1px solid rgba(255, 0, 0, 0.4);\n    color: #ff6666;\n    font-size: 12px;\n    padding: 2px 6px;\n    border-radius: 3px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.section-header .clear-btn:hover {\n    background: rgba(255, 0, 0, 0.3);\n    border-color: #ff0000;\n}\n\n/* Debug active indicator */\n.debug-toggle {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 11px;\n}\n\n.status-dot {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #666;\n    transition: background 0.3s ease;\n}\n\n.status-dot.active {\n    background: #00ff00;\n    box-shadow: 0 0 8px rgba(0, 255, 0, 0.5);\n}\n\n.status-text {\n    font-weight: bold;\n    color: #666;\n    transition: color 0.3s ease;\n}\n\n.status-dot.active + .status-text {\n    color: #00ff00;\n}\n\n/* Debug grid layout */\n.debug-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n    margin-bottom: 8px;\n}\n\n.debug-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 11px;\n    padding: 4px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 3px;\n}\n\n.debug-info .label {\n    color: #888;\n    font-weight: bold;\n}\n\n.debug-info .value {\n    color: #fff;\n    font-weight: normal;\n}\n\n.debug-info .value.on-track {\n    color: #00ff00;\n}\n\n.debug-info .value.off-track {\n    color: #ff0000;\n}\n\n/* Problem areas list */\n.problem-list {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    max-height: 120px;\n    overflow-y: auto;\n}\n\n.problem-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    padding: 6px;\n    background: rgba(0, 0, 0, 0.4);\n    border-radius: 3px;\n    border-left: 3px solid;\n    font-size: 10px;\n}\n\n.problem-item.severity-high {\n    border-left-color: #ff0000;\n    background: rgba(255, 0, 0, 0.1);\n}\n\n.problem-item.severity-medium {\n    border-left-color: #ffaa00;\n    background: rgba(255, 170, 0, 0.1);\n}\n\n.problem-item.severity-low {\n    border-left-color: #ffff00;\n    background: rgba(255, 255, 0, 0.1);\n}\n\n.problem-rank {\n    font-weight: bold;\n    color: #ffff00;\n    min-width: 20px;\n}\n\n.problem-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.problem-location {\n    color: #fff;\n    font-weight: bold;\n}\n\n.problem-count {\n    color: #888;\n    font-size: 9px;\n}\n\n.problem-actions {\n    display: flex;\n    gap: 4px;\n}\n\n.teleport-btn {\n    background: rgba(0, 255, 255, 0.2);\n    border: none;\n    color: #00ffff;\n    font-size: 12px;\n    padding: 2px 4px;\n    border-radius: 2px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.teleport-btn:hover {\n    background: rgba(0, 255, 255, 0.4);\n}\n\n.no-problems,\n.no-history {\n    text-align: center;\n    color: #666;\n    font-style: italic;\n    font-size: 10px;\n    padding: 12px;\n}\n\n/* Position history list */\n.position-list {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n    max-height: 100px;\n    overflow-y: auto;\n    font-size: 10px;\n}\n\n.position-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    padding: 3px 6px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 2px;\n    transition: background 0.2s ease;\n}\n\n.position-item.current {\n    background: rgba(255, 255, 0, 0.2);\n    border: 1px solid rgba(255, 255, 0, 0.4);\n}\n\n.position-index {\n    font-weight: bold;\n    color: #ffff00;\n    min-width: 16px;\n}\n\n.position-coords {\n    color: #fff;\n    flex: 1;\n}\n\n.position-time {\n    color: #888;\n    font-size: 9px;\n}\n\n/* Visual controls */\n.control-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 6px;\n}\n\n.control-item {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 10px;\n    padding: 4px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 3px;\n}\n\n.control-item input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    accent-color: #ffff00;\n}\n\n.control-item span {\n    color: #ccc;\n    font-size: 10px;\n}\n\n/* Performance section specific styles */\n.performance-info .debug-grid {\n    grid-template-columns: 1fr;\n}\n\n/* Legacy debug styles for compatibility */\n#fps-counter {\n    color: #ffff00;\n}\n\n#memory-usage {\n    color: #ff8800;\n}\n\n#connection-status {\n    color: #00ff00;\n}\n\n/* Debug panel responsive adjustments */\n@media (max-width: 768px) {\n    .debug-panel {\n        width: 90vw;\n        left: 5vw;\n        bottom: 10px;\n        max-height: 70vh;\n    }\n    \n    .debug-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .control-grid {\n        grid-template-columns: 1fr;\n    }\n}\n\n@media (max-width: 480px) {\n    .debug-panel {\n        width: calc(100vw - 20px);\n        left: 10px;\n    }\n    \n    .section-header {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 4px;\n    }\n    \n    .section-header h4 {\n        text-align: center;\n    }\n    \n    .section-header .toggle-btn,\n    .section-header .clear-btn {\n        width: 100%;\n        text-align: center;\n    }\n}\n\n/* ===== INVITE MODAL ===== */\n.modal-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n    pointer-events: auto;\n}\n\n.modal-overlay.hidden {\n    display: none !important;\n}\n\n.modal-content {\n    background: #000;\n    border: none;\n    border-radius: 8px;\n    max-width: 600px;\n    width: 90vw;\n    max-height: 80vh;\n    overflow-y: auto;\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);\n}\n\n.invite-content {\n    width: 100%;\n}\n\n.modal-header {\n    background: #00ff00;\n    color: #000;\n    padding: 12px 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: none;\n}\n\n.modal-header h2 {\n    margin: 0;\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.close-btn {\n    background: none;\n    border: none;\n    color: #000;\n    font-size: 24px;\n    cursor: pointer;\n    padding: 0;\n    width: 30px;\n    height: 30px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    transition: background 0.2s ease;\n}\n\n.close-btn:hover {\n    background: rgba(0, 0, 0, 0.2);\n}\n\n.modal-body {\n    padding: 20px;\n    color: #00ff00;\n}\n\n.room-code-section, .share-link-section, .qr-code-section, .social-share-section {\n    margin-bottom: 20px;\n    padding: 16px;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 6px;\n    background: rgba(0, 255, 0, 0.05);\n}\n\n.room-code-section h3, .share-link-section h3, .qr-code-section h3, .social-share-section h3 {\n    margin: 0 0 12px 0;\n    color: #00ff00;\n    font-size: 14px;\n    font-weight: bold;\n}\n\n.room-code-display, .share-link-display {\n    display: flex;\n    gap: 8px;\n    align-items: center;\n}\n\n#room-code-text {\n    background: #000;\n    color: #00ff00;\n    padding: 12px 16px;\n    border: 2px solid #00ff00;\n    border-radius: 4px;\n    font-size: 24px;\n    font-weight: bold;\n    letter-spacing: 2px;\n    text-align: center;\n    flex: 1;\n    box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);\n}\n\n#share-link-input {\n    background: #000;\n    color: #00ff00;\n    border: 1px solid #00ff00;\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-family: inherit;\n    font-size: 12px;\n    flex: 1;\n}\n\n.copy-btn {\n    background: #00ff00;\n    color: #000;\n    border: none;\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-family: inherit;\n    font-weight: bold;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.copy-btn:hover {\n    background: #00cc00;\n    transform: translateY(-1px);\n}\n\n.copy-btn.copy-success {\n    background: #00aa00;\n    color: #fff;\n}\n\n.copy-btn.copy-error {\n    background: #aa0000;\n    color: #fff;\n}\n\n.qr-code-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    min-height: 200px;\n    position: relative;\n}\n\n#qr-code-canvas {\n    border: 2px solid #00ff00;\n    border-radius: 4px;\n    background: #fff;\n    display: none;\n}\n\n.qr-code-placeholder {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 12px;\n    color: #888;\n}\n\n.loading-spinner {\n    width: 30px;\n    height: 30px;\n    border: 3px solid rgba(0, 255, 0, 0.3);\n    border-top: none;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n.social-buttons {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));\n    gap: 8px;\n}\n\n.social-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 4px;\n    padding: 10px 12px;\n    font-family: inherit;\n    font-weight: bold;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: all 0.2s ease;\n    font-size: 11px;\n}\n\n.social-btn:hover {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n    transform: translateY(-1px);\n}\n\n.twitter-btn:hover {\n    background: rgba(29, 161, 242, 0.3);\n    border-color: #1da1f2;\n    color: #1da1f2;\n}\n\n.discord-btn:hover {\n    background: rgba(114, 137, 218, 0.3);\n    border-color: #7289da;\n    color: #7289da;\n}\n\n.whatsapp-btn:hover {\n    background: rgba(37, 211, 102, 0.3);\n    border-color: #25d366;\n    color: #25d366;\n}\n\n.email-btn:hover {\n    background: rgba(234, 67, 53, 0.3);\n    border-color: #ea4335;\n    color: #ea4335;\n}\n\n.quick-actions {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    margin-top: 20px;\n}\n\n.quick-actions .action-btn {\n    padding: 12px 20px;\n    font-size: 14px;\n    border-radius: 6px;\n    min-width: 120px;\n}\n\n.quick-actions .action-btn.enabled {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n    color: #00ff00;\n}\n\n.quick-actions .action-btn.enabled:hover {\n    background: #00ff00;\n    color: #000;\n}\n\n/* ===== RACE TIMER ===== */\n.race-timer {\n    position: absolute;\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: rgba(255, 0, 0, 0.9);\n    color: #fff;\n    padding: 8px 16px;\n    border: 2px solid #ff0000;\n    border-radius: 6px;\n    font-size: 18px;\n    font-weight: bold;\n    box-shadow: 0 0 20px rgba(255, 0, 0, 0.5);\n    pointer-events: auto;\n}\n\n.race-timer.hidden {\n    display: none !important;\n}\n\n/* ===== PANEL TOGGLES ===== */\n.panel-toggles {\n    position: absolute;\n    bottom: 20px;\n    right: 20px;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    pointer-events: auto;\n}\n\n.toggle-btn {\n    background: rgba(0, 0, 0, 0.8);\n    color: #00ff00;\n    border: 1px solid #00ff00;\n    border-radius: 4px;\n    padding: 6px 8px;\n    font-family: inherit;\n    font-size: 10px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    white-space: nowrap;\n}\n\n.toggle-btn:hover {\n    background: #00ff00;\n    color: #000;\n    transform: translateX(-2px);\n}\n\n/* ===== NOTIFICATIONS ===== */\n.notification {\n    position: absolute;\n    bottom: -40px;\n    left: 50%;\n    transform: translateX(-50%);\n    background: #000;\n    color: #00ff00;\n    border: 1px solid #00ff00;\n    border-radius: 4px;\n    padding: 8px 12px;\n    font-size: 12px;\n    font-weight: bold;\n    white-space: nowrap;\n    pointer-events: none;\n    opacity: 0;\n    transition: all 0.3s ease;\n    z-index: 1001;\n}\n\n.notification.show {\n    opacity: 1;\n    bottom: -30px;\n}\n\n.notification.success {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #00ff00;\n    color: #00ff00;\n}\n\n.notification.error {\n    background: rgba(255, 0, 0, 0.2);\n    border-color: #ff0000;\n    color: #ff0000;\n}\n\n.notification.info {\n    background: rgba(0, 255, 255, 0.2);\n    border-color: #00ffff;\n    color: #00ffff;\n}\n\n/* ===== RESPONSIVE DESIGN ===== */\n@media (max-width: 768px) {\n    .ui-panel {\n        max-width: 90vw;\n    }\n    \n    .player-info {\n        width: 200px;\n    }\n    \n    .betting-panel {\n        width: 90vw;\n    }\n    \n    .leaderboard-panel {\n        width: 90vw;\n        right: 5vw;\n    }\n    \n    .modal-content {\n        width: 95vw;\n        margin: 10px;\n    }\n    \n    .social-buttons {\n        grid-template-columns: repeat(2, 1fr);\n    }\n    \n    .quick-actions {\n        flex-direction: column;\n    }\n    \n    .players-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .panel-toggles {\n        flex-direction: row;\n        bottom: 10px;\n        right: 10px;\n    }\n}\n\n@media (max-width: 480px) {\n    .ui-overlay {\n        font-size: 12px;\n    }\n    \n    .player-info {\n        top: 10px;\n        left: 10px;\n        width: calc(100vw - 20px);\n        max-width: 250px;\n    }\n    \n    .betting-panel {\n        bottom: 60px;\n        width: calc(100vw - 20px);\n    }\n    \n    .leaderboard-panel {\n        top: 10px;\n        right: 10px;\n        width: calc(100vw - 20px);\n        max-width: 300px;\n    }\n    \n    .debug-panel {\n        bottom: 10px;\n        left: 10px;\n        width: calc(100vw - 20px);\n        max-width: 250px;\n    }\n    \n    #room-code-text {\n        font-size: 18px;\n        padding: 8px 12px;\n    }\n    \n    .room-code-display, .share-link-display {\n        flex-direction: column;\n        gap: 6px;\n    }\n    \n    .copy-btn {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n/* ===== ACCESSIBILITY ===== */\n@media (prefers-reduced-motion: reduce) {\n    *, *::before, *::after {\n        animation-duration: 0.01ms !important;\n        animation-iteration-count: 1 !important;\n        transition-duration: 0.01ms !important;\n    }\n    \n    .loading-spinner {\n        animation: none;\n        border: none;\n    }\n}\n\n/* Focus styles for keyboard navigation */\n.ui-panel:focus,\n.toggle-btn:focus,\n.action-btn:focus,\n.bet-button:focus,\n.copy-btn:focus,\n.social-btn:focus {\n    outline: 2px solid #ffff00;\n    outline-offset: 2px;\n}\n\n/* High contrast mode support */\n@media (prefers-contrast: high) {\n    .ui-panel {\n        border-width: 3px;\n        background: #000;\n    }\n    \n    .panel-header {\n        background: #00ff00;\n        color: #000;\n    }\n    \n    .notification {\n        border-width: 2px;\n    }\n}\n\n/* ===== MAP SELECTION PANEL ===== */\n.map-selection-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.85);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n    pointer-events: auto;\n}\n\n.map-selection-modal {\n    background: #000;\n    border: none;\n    border-radius: 8px;\n    max-width: 800px;\n    width: 90vw;\n    max-height: 90vh;\n    overflow-y: auto;\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);\n}\n\n.map-selection-content {\n    width: 100%;\n}\n\n.map-selection-panel .panel-header {\n    background: #00ff00;\n    color: #000;\n    padding: 12px 16px;\n    border-bottom: none;\n}\n\n.map-selection-panel .panel-title {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    width: 100%;\n}\n\n.pixel-text {\n    font-family: 'Courier New', monospace;\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 18px;\n    text-align: center;\n}\n\n.rotation-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n    color: #000;\n}\n\n.rotation-text {\n    font-weight: bold;\n}\n\n.race-counter {\n    display: flex;\n    gap: 6px;\n    align-items: center;\n}\n\n.race-counter .label {\n    font-weight: normal;\n}\n\n.race-counter .value {\n    font-weight: bold;\n    color: #ff0000;\n}\n\n.map-selection-content .panel-body {\n    padding: 20px;\n    color: #00ff00;\n}\n\n.maps-grid {\n    display: grid;\n    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n    gap: 16px;\n    margin-bottom: 20px;\n}\n\n.map-option {\n    background: rgba(0, 255, 0, 0.05);\n    border: 2px solid rgba(0, 255, 0, 0.3);\n    border-radius: 8px;\n    padding: 8px;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    position: relative;\n    overflow: hidden;\n}\n\n.map-option:hover {\n    border-color: #ffff00;\n    box-shadow: 0 0 15px rgba(255, 255, 0, 0.3);\n    transform: translateY(-2px);\n}\n\n.map-option.selected {\n    border-color: #ffff00;\n    border-width: 4px;\n    background: rgba(255, 255, 0, 0.1);\n    box-shadow: 0 0 20px rgba(255, 255, 0, 0.4);\n}\n\n.map-preview {\n    width: 100%;\n    height: 140px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 8px;\n    border-radius: 4px;\n    overflow: hidden;\n    background: #111;\n}\n\n.preview-canvas {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n.map-info {\n    text-align: center;\n}\n\n.map-title {\n    font-weight: bold;\n    font-size: 14px;\n    color: #00ff00;\n    margin-bottom: 4px;\n}\n\n.map-difficulty-badge {\n    display: inline-block;\n    padding: 2px 8px;\n    border-radius: 12px;\n    font-size: 10px;\n    font-weight: bold;\n    text-transform: uppercase;\n}\n\n.difficulty-easy {\n    background: rgba(0, 255, 0, 0.2);\n    color: #00ff00;\n    border: 1px solid #00ff00;\n}\n\n.difficulty-medium {\n    background: rgba(255, 255, 0, 0.2);\n    color: #ffff00;\n    border: 1px solid #ffff00;\n}\n\n.difficulty-hard {\n    background: rgba(255, 165, 0, 0.2);\n    color: #ffa500;\n    border: 1px solid #ffa500;\n}\n\n.difficulty-very-hard {\n    background: rgba(255, 0, 0, 0.2);\n    color: #ff0000;\n    border: 1px solid #ff0000;\n}\n\n.selection-info {\n    margin-bottom: 20px;\n    padding: 16px;\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 6px;\n}\n\n.selected-map-details {\n    text-align: center;\n}\n\n.map-name {\n    font-size: 20px;\n    font-weight: bold;\n    color: #00ff00;\n    margin-bottom: 8px;\n}\n\n.map-description {\n    font-size: 14px;\n    color: #ccc;\n    margin-bottom: 8px;\n}\n\n.map-difficulty {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    font-size: 12px;\n}\n\n.difficulty-label {\n    color: #888;\n}\n\n.difficulty-value {\n    font-weight: bold;\n}\n\n.selection-controls {\n    display: flex;\n    gap: 12px;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.selection-controls .action-btn {\n    padding: 12px 20px;\n    font-size: 14px;\n    border-radius: 6px;\n    min-width: 140px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 6px;\n    transition: all 0.2s ease;\n}\n\n.confirm-btn {\n    background: rgba(0, 255, 0, 0.3);\n    border: 2px solid #00ff00;\n    color: #00ff00;\n}\n\n.confirm-btn:hover {\n    background: #00ff00;\n    color: #000;\n    transform: translateY(-1px);\n}\n\n.random-btn {\n    background: rgba(255, 255, 0, 0.3);\n    border: 2px solid #ffff00;\n    color: #ffff00;\n}\n\n.random-btn:hover {\n    background: #ffff00;\n    color: #000;\n    transform: translateY(-1px);\n}\n\n.cancel-btn {\n    background: rgba(255, 0, 0, 0.3);\n    border: 2px solid #ff0000;\n    color: #ff0000;\n}\n\n.cancel-btn:hover {\n    background: #ff0000;\n    color: #fff;\n    transform: translateY(-1px);\n}\n\n.current-map-info {\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n    padding-top: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.info-row {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 12px;\n}\n\n.info-row .label {\n    color: #888;\n}\n\n.info-row .value {\n    color: #00ff00;\n    font-weight: bold;\n}\n\n.btn-icon {\n    font-size: 16px;\n}\n\n/* Map selection notifications */\n#map-selection-notification {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    background: rgba(0, 0, 0, 0.9);\n    border: 2px solid #00ff00;\n    border-radius: 6px;\n    padding: 12px 20px;\n    font-size: 14px;\n    font-weight: bold;\n    z-index: 2001;\n    pointer-events: none;\n    opacity: 0;\n    transition: all 0.3s ease;\n}\n\n#map-selection-notification.show {\n    opacity: 1;\n}\n\n#map-selection-notification.success {\n    border-color: #00ff00;\n    color: #00ff00;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n#map-selection-notification.error {\n    border-color: #ff0000;\n    color: #ff0000;\n    background: rgba(255, 0, 0, 0.1);\n}\n\n#map-selection-notification.info {\n    border-color: #00ffff;\n    color: #00ffff;\n    background: rgba(0, 255, 255, 0.1);\n}\n\n/* Responsive design for map selection */\n@media (max-width: 768px) {\n    .map-selection-modal {\n        width: 95vw;\n        max-height: 95vh;\n    }\n    \n    .maps-grid {\n        grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n        gap: 12px;\n    }\n    \n    .map-preview {\n        height: 100px;\n    }\n    \n    .selection-controls {\n        flex-direction: column;\n    }\n    \n    .selection-controls .action-btn {\n        min-width: auto;\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .map-selection-content .panel-body {\n        padding: 15px;\n    }\n    \n    .maps-grid {\n        grid-template-columns: 1fr;\n        gap: 10px;\n    }\n    \n    .map-preview {\n        height: 120px;\n    }\n    \n    .pixel-text {\n        font-size: 16px;\n    }\n    \n    .rotation-info {\n        flex-direction: column;\n        gap: 4px;\n        text-align: center;\n    }\n}\n\n/* ===== PLAYER SETUP PANEL ===== */\n.ui-panel.player-setup {\n    top: 10px;\n    right: 10px;\n    width: 320px;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.current-player-display {\n    text-align: center;\n    font-size: 18px;\n    font-weight: bold;\n    padding: 10px;\n    margin-bottom: 15px;\n    background: rgba(0, 255, 0, 0.1);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n}\n\n.player-customization-section {\n    margin-bottom: 20px;\n}\n\n.customization-container {\n    padding: 10px;\n    background: rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n}\n\n.name-input-section {\n    margin-bottom: 15px;\n}\n\n.input-label {\n    display: block;\n    font-size: 12px;\n    font-weight: bold;\n    margin-bottom: 5px;\n    color: #00ff00;\n}\n\n.player-name-input {\n    width: 100%;\n    padding: 8px;\n    background: #000;\n    color: #00ff00;\n    border: 2px solid #00ff00;\n    border-radius: 3px;\n    font-family: 'Courier New', monospace;\n    font-size: 14px;\n    text-transform: uppercase;\n}\n\n.player-name-input:focus {\n    outline: none;\n    border-color: #00ff00;\n    box-shadow: 0 0 5px rgba(0, 255, 0, 0.5);\n}\n\n.input-hint {\n    font-size: 11px;\n    color: #888;\n    margin-top: 3px;\n}\n\n.image-upload-section {\n    text-align: center;\n}\n\n.file-upload-btn {\n    display: inline-block;\n    cursor: pointer;\n    background: #0066ff;\n    color: #fff;\n    padding: 8px 15px;\n    margin: 10px 0;\n    border: 2px solid #0088ff;\n    border-radius: 4px;\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n    font-weight: bold;\n    text-transform: uppercase;\n    transition: background 0.2s ease;\n}\n\n.file-upload-btn:hover {\n    background: #0044cc;\n    border-color: #0066ff;\n}\n\n.btn-icon {\n    margin-right: 5px;\n}\n\n.image-preview-container {\n    margin: 10px 0;\n}\n\n.player-preview {\n    max-width: 128px;\n    max-height: 128px;\n    border: 2px solid #00ff00;\n    border-radius: 4px;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n.upload-hints {\n    margin-top: 10px;\n}\n\n.hint-item {\n    font-size: 10px;\n    color: #888;\n    margin: 2px 0;\n}\n\n.join-race-section {\n    margin-bottom: 20px;\n    text-align: center;\n}\n\n.join-race-btn {\n    width: 100%;\n    padding: 12px;\n    background: #00ff00;\n    color: #000;\n    border: 2px solid #00ff00;\n    border-radius: 4px;\n    font-family: 'Courier New', monospace;\n    font-size: 14px;\n    font-weight: bold;\n    text-transform: uppercase;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.join-race-btn:hover:not(:disabled) {\n    background: #00cc00;\n    border-color: #00cc00;\n    transform: translateY(-1px);\n}\n\n.join-race-btn:disabled,\n.join-race-btn.joined {\n    background: #666;\n    border-color: #666;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.join-status {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    margin-top: 10px;\n    padding: 8px;\n    background: rgba(0, 255, 0, 0.1);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    color: #00ff00;\n    font-size: 12px;\n}\n\n.status-icon {\n    font-size: 16px;\n}\n\n.preparation-info,\n.controls-help {\n    margin-bottom: 15px;\n    padding: 10px;\n    background: rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n}\n\n.info-header,\n.help-header {\n    font-size: 12px;\n    font-weight: bold;\n    color: #00ff00;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n}\n\n.info-content,\n.help-content {\n    font-size: 11px;\n}\n\n.info-item,\n.control-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 5px 0;\n}\n\n.info-icon {\n    font-size: 14px;\n    width: 16px;\n    text-align: center;\n}\n\n.key-badge {\n    background: #333;\n    color: #00ff00;\n    padding: 2px 6px;\n    border-radius: 3px;\n    font-size: 10px;\n    font-weight: bold;\n    min-width: 20px;\n    text-align: center;\n}\n\n.control-desc {\n    color: #ccc;\n    font-size: 11px;\n}\n\n.current-map-display {\n    padding: 10px;\n    background: rgba(0, 0, 0, 0.5);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n}\n\n.map-info-header {\n    font-size: 12px;\n    font-weight: bold;\n    color: #00ff00;\n    margin-bottom: 8px;\n    text-transform: uppercase;\n}\n\n.map-info-content {\n    font-size: 11px;\n}\n\n.map-name {\n    color: #fff;\n    font-weight: bold;\n    margin-bottom: 5px;\n}\n\n.map-rotation-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.rotation-label {\n    color: #888;\n}\n\n.rotation-count {\n    color: #ffff00;\n    font-weight: bold;\n}\n\n/* Drag and drop styling */\n.ui-panel.player-setup.drag-over {\n    border-color: #ffff00;\n    box-shadow: 0 0 20px rgba(255, 255, 0, 0.5);\n}\n\n.ui-panel.player-setup.drag-over .customization-container {\n    border-color: #ffff00;\n    background: rgba(255, 255, 0, 0.1);\n}\n\n/* Player setup notification */\n#player-setup-notification {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n    padding: 8px;\n    border-radius: 4px;\n    font-size: 11px;\n    text-align: center;\n    opacity: 0;\n    transform: translateY(10px);\n    transition: all 0.3s ease;\n    pointer-events: none;\n}\n\n#player-setup-notification.show {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n#player-setup-notification.success {\n    background: rgba(0, 255, 0, 0.2);\n    border: 1px solid #00ff00;\n    color: #00ff00;\n}\n\n#player-setup-notification.error {\n    background: rgba(255, 0, 0, 0.2);\n    border: 1px solid #ff0000;\n    color: #ff6666;\n}\n\n#player-setup-notification.info {\n    background: rgba(0, 150, 255, 0.2);\n    border: 1px solid #0096ff;\n    color: #66ccff;\n}\n\n/* Responsive adjustments for player setup */\n@media (max-width: 768px) {\n    .ui-panel.player-setup {\n        width: 90vw;\n        right: 5vw;\n        max-height: 80vh;\n    }\n    \n    .current-player-display {\n        font-size: 16px;\n        padding: 8px;\n    }\n    \n    .join-race-btn {\n        padding: 10px;\n        font-size: 12px;\n    }\n    \n    .file-upload-btn {\n        padding: 6px 12px;\n        font-size: 11px;\n    }\n}\n\n/* ===== ASSET BROWSER PANEL ===== */\n.ui-panel.asset-browser {\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 700px;\n    max-width: 90vw;\n    max-height: 85vh;\n    overflow: hidden;\n}\n\n.asset-browser-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    max-height: 600px;\n}\n\n.browser-toolbar {\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n    padding-bottom: 12px;\n    margin-bottom: 12px;\n}\n\n.category-tabs {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 12px;\n    overflow-x: auto;\n    padding-bottom: 4px;\n}\n\n.category-tab {\n    background: rgba(0, 255, 0, 0.1);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 6px 10px;\n    font-family: inherit;\n    font-size: 11px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.category-tab:hover {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #00ff00;\n}\n\n.category-tab.active {\n    background: rgba(255, 255, 0, 0.2);\n    border-color: #ffff00;\n    color: #ffff00;\n    font-weight: bold;\n}\n\n.tab-icon {\n    font-size: 14px;\n}\n\n.tab-name {\n    font-size: 10px;\n}\n\n.search-section {\n    display: flex;\n    align-items: center;\n    gap: 4px;\n}\n\n.search-input {\n    flex: 1;\n    background: #000;\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 3px;\n    padding: 6px 8px;\n    font-family: inherit;\n    font-size: 12px;\n}\n\n.search-input:focus {\n    outline: none;\n    border-color: #00ff00;\n    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);\n}\n\n.search-clear-btn {\n    background: rgba(255, 0, 0, 0.2);\n    color: #ff6666;\n    border: 1px solid rgba(255, 0, 0, 0.4);\n    border-radius: 3px;\n    padding: 6px 8px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: all 0.2s ease;\n}\n\n.search-clear-btn:hover {\n    background: rgba(255, 0, 0, 0.3);\n    border-color: #ff0000;\n}\n\n.asset-grid-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n}\n\n.category-info {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 8px;\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    margin-bottom: 8px;\n}\n\n.category-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    font-weight: bold;\n    color: #00ff00;\n}\n\n.category-icon {\n    font-size: 16px;\n}\n\n.asset-count {\n    font-size: 11px;\n    color: #888;\n}\n\n.asset-grid {\n    flex: 1;\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));\n    gap: 8px;\n    overflow-y: auto;\n    padding: 8px;\n    background: rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    max-height: 300px;\n}\n\n.asset-item {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 6px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    position: relative;\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n}\n\n.asset-item:hover {\n    border-color: #ffff00;\n    box-shadow: 0 0 10px rgba(255, 255, 0, 0.2);\n    transform: translateY(-1px);\n}\n\n.asset-item.selected {\n    border-color: #ffff00;\n    border-width: 2px;\n    background: rgba(255, 255, 0, 0.1);\n    box-shadow: 0 0 15px rgba(255, 255, 0, 0.3);\n}\n\n.asset-item.dragging {\n    opacity: 0.7;\n    transform: scale(0.95);\n}\n\n.asset-item.error {\n    border-color: rgba(255, 0, 0, 0.5);\n    background: rgba(255, 0, 0, 0.05);\n}\n\n.asset-thumbnail {\n    width: 100%;\n    height: 64px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #111;\n    border-radius: 3px;\n    overflow: hidden;\n}\n\n.thumbnail-canvas {\n    max-width: 100%;\n    max-height: 100%;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n.error-thumbnail {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 0, 0, 0.1);\n    color: #ff6666;\n}\n\n.error-thumbnail .error-icon {\n    font-size: 24px;\n}\n\n.asset-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.asset-name {\n    font-size: 11px;\n    font-weight: bold;\n    color: #fff;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.asset-meta {\n    font-size: 9px;\n    color: #888;\n}\n\n.asset-dimensions {\n    color: #00ff00;\n}\n\n.error-text {\n    color: #ff6666;\n}\n\n.asset-actions {\n    display: flex;\n    gap: 2px;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.asset-item:hover .asset-actions {\n    opacity: 1;\n}\n\n.asset-action-btn {\n    background: rgba(0, 0, 0, 0.8);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 2px;\n    padding: 2px 4px;\n    cursor: pointer;\n    font-size: 10px;\n    transition: all 0.2s ease;\n    flex: 1;\n}\n\n.asset-action-btn:hover {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #00ff00;\n}\n\n.asset-actions .apply-btn:hover {\n    background: rgba(0, 255, 0, 0.3);\n    color: #000;\n}\n\n.asset-actions .retry-btn {\n    color: #ffaa00;\n    border-color: rgba(255, 170, 0, 0.5);\n}\n\n.asset-actions .retry-btn:hover {\n    background: rgba(255, 170, 0, 0.2);\n    border-color: #ffaa00;\n}\n\n.loading-placeholder,\n.empty-placeholder,\n.error-placeholder {\n    grid-column: 1 / -1;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 12px;\n    padding: 40px 20px;\n    color: #888;\n    text-align: center;\n}\n\n.loading-spinner {\n    width: 30px;\n    height: 30px;\n    border: 3px solid rgba(0, 255, 0, 0.3);\n    border-top: none;\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n.empty-icon,\n.error-icon {\n    font-size: 48px;\n    opacity: 0.5;\n}\n\n.empty-text,\n.error-text,\n.loading-text {\n    font-size: 14px;\n    font-weight: bold;\n    color: #666;\n}\n\n.empty-subtitle {\n    font-size: 12px;\n    color: #555;\n}\n\n.retry-btn {\n    background: rgba(0, 255, 0, 0.2);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 4px;\n    padding: 6px 12px;\n    font-family: inherit;\n    font-size: 11px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.retry-btn:hover {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n}\n\n.asset-preview-section {\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n    padding-top: 12px;\n    margin-top: 12px;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    padding: 12px;\n}\n\n.preview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 12px;\n}\n\n.preview-title {\n    font-size: 12px;\n    font-weight: bold;\n    color: #00ff00;\n    text-transform: uppercase;\n}\n\n.preview-close-btn {\n    background: rgba(255, 0, 0, 0.2);\n    color: #ff6666;\n    border: 1px solid rgba(255, 0, 0, 0.4);\n    border-radius: 3px;\n    padding: 4px 6px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: all 0.2s ease;\n}\n\n.preview-close-btn:hover {\n    background: rgba(255, 0, 0, 0.3);\n    border-color: #ff0000;\n}\n\n.preview-content {\n    display: grid;\n    grid-template-columns: auto 1fr auto;\n    gap: 12px;\n    align-items: center;\n}\n\n.preview-canvas-container {\n    width: 128px;\n    height: 128px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: #111;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n}\n\n.preview-canvas {\n    max-width: 100%;\n    max-height: 100%;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n.asset-details {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    font-size: 11px;\n}\n\n.preview-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.preview-actions .action-btn {\n    padding: 8px 12px;\n    font-size: 11px;\n    border-radius: 4px;\n    min-width: 120px;\n}\n\n.apply-btn {\n    background: rgba(0, 255, 0, 0.2);\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    color: #00ff00;\n}\n\n.apply-btn:hover:not(:disabled) {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n}\n\n.export-btn {\n    background: rgba(0, 150, 255, 0.2);\n    border: 1px solid rgba(0, 150, 255, 0.5);\n    color: #0096ff;\n}\n\n.export-btn:hover:not(:disabled) {\n    background: rgba(0, 150, 255, 0.3);\n    border-color: #0096ff;\n}\n\n.upload-section {\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n    padding-top: 12px;\n    margin-top: 12px;\n}\n\n.upload-area {\n    border: 2px dashed rgba(0, 255, 0, 0.3);\n    border-radius: 6px;\n    padding: 20px;\n    text-align: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    background: rgba(0, 255, 0, 0.02);\n    margin-bottom: 8px;\n}\n\n.upload-area:hover {\n    border-color: #00ff00;\n    background: rgba(0, 255, 0, 0.05);\n}\n\n.upload-area.drag-over {\n    border-color: #ffff00;\n    background: rgba(255, 255, 0, 0.1);\n    border-style: solid;\n}\n\n.upload-area.uploading {\n    opacity: 0.7;\n    pointer-events: none;\n}\n\n.upload-icon {\n    font-size: 32px;\n    margin-bottom: 8px;\n    color: #00ff00;\n}\n\n.upload-title {\n    font-size: 14px;\n    font-weight: bold;\n    color: #00ff00;\n    margin-bottom: 4px;\n}\n\n.upload-subtitle {\n    font-size: 12px;\n    color: #888;\n}\n\n.upload-hints {\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.upload-hints .hint-item {\n    font-size: 10px;\n    color: #666;\n    text-align: center;\n}\n\n.refresh-btn {\n    background: rgba(0, 150, 255, 0.2);\n    color: #66ccff;\n    border: 1px solid rgba(0, 150, 255, 0.4);\n}\n\n.refresh-btn:hover {\n    background: rgba(0, 150, 255, 0.3);\n    border-color: #0096ff;\n    color: #0096ff;\n}\n\n/* Asset browser notification */\n#asset-browser-notification {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n    padding: 8px;\n    border-radius: 4px;\n    font-size: 11px;\n    text-align: center;\n    opacity: 0;\n    transform: translateY(10px);\n    transition: all 0.3s ease;\n    pointer-events: none;\n}\n\n#asset-browser-notification.show {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n#asset-browser-notification.success {\n    background: rgba(0, 255, 0, 0.2);\n    border: 1px solid #00ff00;\n    color: #00ff00;\n}\n\n#asset-browser-notification.error {\n    background: rgba(255, 0, 0, 0.2);\n    border: 1px solid #ff0000;\n    color: #ff6666;\n}\n\n#asset-browser-notification.info {\n    background: rgba(0, 150, 255, 0.2);\n    border: 1px solid #0096ff;\n    color: #66ccff;\n}\n\n/* Responsive adjustments for asset browser */\n@media (max-width: 768px) {\n    .ui-panel.asset-browser {\n        width: 95vw;\n        left: 2.5vw;\n        transform: none;\n        max-height: 90vh;\n    }\n    \n    .asset-grid {\n        grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));\n        gap: 6px;\n        max-height: 250px;\n    }\n    \n    .category-tabs {\n        gap: 2px;\n    }\n    \n    .category-tab {\n        padding: 4px 6px;\n        font-size: 10px;\n    }\n    \n    .tab-name {\n        display: none;\n    }\n    \n    .preview-content {\n        grid-template-columns: 1fr;\n        gap: 8px;\n    }\n    \n    .preview-canvas-container {\n        width: 100px;\n        height: 100px;\n        margin: 0 auto;\n    }\n    \n    .preview-actions {\n        flex-direction: row;\n        justify-content: center;\n    }\n    \n    .preview-actions .action-btn {\n        min-width: auto;\n        flex: 1;\n    }\n}\n\n@media (max-width: 480px) {\n    .ui-panel.asset-browser {\n        width: 100vw;\n        left: 0;\n        top: 0;\n        max-height: 100vh;\n        border-radius: 0;\n    }\n    \n    .asset-grid {\n        grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));\n        max-height: 200px;\n    }\n    \n    .asset-item {\n        padding: 4px;\n    }\n    \n    .asset-thumbnail {\n        height: 48px;\n    }\n    \n    .asset-name {\n        font-size: 10px;\n    }\n    \n    .asset-meta {\n        font-size: 8px;\n    }\n    \n    .upload-area {\n        padding: 15px;\n    }\n    \n    .upload-icon {\n        font-size: 24px;\n    }\n}\n\n/* ===== PRESET MANAGER PANEL ===== */\n.ui-panel.preset-manager {\n    top: 20px;\n    left: 50%;\n    transform: translateX(-50%);\n    width: 650px;\n    max-width: 90vw;\n    max-height: 85vh;\n    overflow: hidden;\n}\n\n.preset-manager-content {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n    max-height: 600px;\n    gap: 12px;\n}\n\n/* Category tabs */\n.preset-categories {\n    display: flex;\n    gap: 4px;\n    margin-bottom: 8px;\n    overflow-x: auto;\n    padding-bottom: 4px;\n}\n\n.category-tab {\n    background: rgba(0, 255, 0, 0.1);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 6px 10px;\n    font-family: inherit;\n    font-size: 11px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    white-space: nowrap;\n    flex-shrink: 0;\n}\n\n.category-tab:hover {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #00ff00;\n}\n\n.category-tab.active {\n    background: rgba(255, 255, 0, 0.2);\n    border-color: #ffff00;\n    color: #ffff00;\n    font-weight: bold;\n}\n\n.tab-icon {\n    font-size: 14px;\n}\n\n.tab-name {\n    font-size: 10px;\n}\n\n/* Category info */\n.current-category-info {\n    padding: 8px;\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    margin-bottom: 8px;\n}\n\n.category-header {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 14px;\n    font-weight: bold;\n    color: #00ff00;\n    margin-bottom: 4px;\n}\n\n.category-icon {\n    font-size: 16px;\n}\n\n.category-description {\n    font-size: 11px;\n    color: #ccc;\n    margin-bottom: 6px;\n}\n\n.category-stats {\n    display: flex;\n    gap: 12px;\n    font-size: 10px;\n    color: #888;\n}\n\n.preset-count {\n    color: #00ff00;\n}\n\n.config-types {\n    color: #ffaa00;\n}\n\n/* Preset list */\n.preset-list-container {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    overflow: hidden;\n    margin-bottom: 12px;\n}\n\n.preset-list {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n    overflow-y: auto;\n    padding: 8px;\n    background: rgba(0, 0, 0, 0.3);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    max-height: 250px;\n}\n\n.preset-item {\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    padding: 8px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n}\n\n.preset-item:hover {\n    border-color: #ffff00;\n    box-shadow: 0 0 10px rgba(255, 255, 0, 0.2);\n    transform: translateY(-1px);\n}\n\n.preset-item.selected {\n    border-color: #ffff00;\n    border-width: 2px;\n    background: rgba(255, 255, 0, 0.1);\n    box-shadow: 0 0 15px rgba(255, 255, 0, 0.3);\n}\n\n.preset-header {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin-bottom: 4px;\n}\n\n.preset-icon {\n    font-size: 16px;\n    color: #00ff00;\n    width: 20px;\n    text-align: center;\n    flex-shrink: 0;\n}\n\n.preset-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    gap: 2px;\n}\n\n.preset-name {\n    font-size: 12px;\n    font-weight: bold;\n    color: #fff;\n}\n\n.preset-meta {\n    display: flex;\n    gap: 8px;\n    font-size: 10px;\n    color: #888;\n}\n\n.preset-author {\n    color: #00ff00;\n}\n\n.preset-date {\n    color: #aaa;\n}\n\n.preset-actions {\n    display: flex;\n    gap: 2px;\n    opacity: 0;\n    transition: opacity 0.2s ease;\n}\n\n.preset-item:hover .preset-actions {\n    opacity: 1;\n}\n\n.preset-action-btn {\n    background: rgba(0, 0, 0, 0.8);\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 2px;\n    padding: 2px 4px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: all 0.2s ease;\n    min-width: 24px;\n    text-align: center;\n}\n\n.preset-action-btn:hover {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #00ff00;\n}\n\n.preset-action-btn.delete-btn:hover {\n    background: rgba(255, 0, 0, 0.2);\n    border-color: #ff0000;\n    color: #ff6666;\n}\n\n.preset-description {\n    font-size: 11px;\n    color: #ccc;\n    margin-bottom: 4px;\n    line-height: 1.3;\n}\n\n.preset-tags {\n    display: flex;\n    gap: 4px;\n    flex-wrap: wrap;\n}\n\n.preset-tag {\n    background: rgba(0, 150, 255, 0.2);\n    color: #66ccff;\n    border: 1px solid rgba(0, 150, 255, 0.4);\n    border-radius: 8px;\n    padding: 1px 6px;\n    font-size: 9px;\n    font-weight: bold;\n}\n\n/* Empty state */\n.empty-preset-list {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 8px;\n    padding: 40px 20px;\n    color: #666;\n    text-align: center;\n    min-height: 150px;\n}\n\n.empty-icon {\n    font-size: 48px;\n    opacity: 0.5;\n}\n\n.empty-text {\n    font-size: 14px;\n    font-weight: bold;\n    color: #888;\n}\n\n.empty-subtitle {\n    font-size: 12px;\n    color: #666;\n}\n\n/* Action buttons */\n.preset-actions {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n}\n\n.action-group {\n    display: flex;\n    gap: 6px;\n}\n\n.quick-actions .action-btn {\n    flex: 1;\n}\n\n.file-actions .action-btn {\n    flex: 1;\n}\n\n.create-btn {\n    background: rgba(0, 255, 0, 0.2);\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    color: #00ff00;\n}\n\n.create-btn:hover:not(:disabled) {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n}\n\n.save-btn {\n    background: rgba(0, 150, 255, 0.2);\n    border: 1px solid rgba(0, 150, 255, 0.5);\n    color: #0096ff;\n}\n\n.save-btn:hover:not(:disabled) {\n    background: rgba(0, 150, 255, 0.3);\n    border-color: #0096ff;\n}\n\n.load-btn {\n    background: rgba(255, 165, 0, 0.2);\n    border: 1px solid rgba(255, 165, 0, 0.5);\n    color: #ffa500;\n}\n\n.load-btn:hover:not(:disabled) {\n    background: rgba(255, 165, 0, 0.3);\n    border-color: #ffa500;\n}\n\n.import-btn {\n    background: rgba(128, 0, 128, 0.2);\n    border: 1px solid rgba(128, 0, 128, 0.5);\n    color: #bb88bb;\n}\n\n.import-btn:hover:not(:disabled) {\n    background: rgba(128, 0, 128, 0.3);\n    border-color: #aa77aa;\n}\n\n.export-btn {\n    background: rgba(255, 20, 147, 0.2);\n    border: 1px solid rgba(255, 20, 147, 0.5);\n    color: #ff69b4;\n}\n\n.export-btn:hover:not(:disabled) {\n    background: rgba(255, 20, 147, 0.3);\n    border-color: #ff1493;\n}\n\n/* Preview section */\n.preset-preview-section {\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n    padding-top: 12px;\n    margin-top: 12px;\n    background: rgba(0, 0, 0, 0.5);\n    border-radius: 4px;\n    padding: 12px;\n}\n\n.preview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 8px;\n}\n\n.preview-title {\n    font-size: 12px;\n    font-weight: bold;\n    color: #00ff00;\n    text-transform: uppercase;\n}\n\n.preview-close-btn {\n    background: rgba(255, 0, 0, 0.2);\n    color: #ff6666;\n    border: 1px solid rgba(255, 0, 0, 0.4);\n    border-radius: 3px;\n    padding: 4px 6px;\n    cursor: pointer;\n    font-size: 12px;\n    transition: all 0.2s ease;\n}\n\n.preview-close-btn:hover {\n    background: rgba(255, 0, 0, 0.3);\n    border-color: #ff0000;\n}\n\n.preview-preset-info h4 {\n    color: #00ff00;\n    margin: 0 0 4px 0;\n    font-size: 14px;\n}\n\n.preview-description {\n    color: #ccc;\n    font-size: 11px;\n    margin: 0 0 6px 0;\n}\n\n.preview-meta {\n    display: flex;\n    gap: 12px;\n    font-size: 10px;\n    margin-bottom: 8px;\n}\n\n.preview-author {\n    color: #00ff00;\n}\n\n.preview-date {\n    color: #888;\n}\n\n.preview-config-summary h5 {\n    color: #ffff00;\n    margin: 0 0 6px 0;\n    font-size: 12px;\n}\n\n.config-items {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    margin-bottom: 8px;\n}\n\n.config-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px;\n    background: rgba(0, 0, 0, 0.3);\n    border-radius: 3px;\n    font-size: 10px;\n}\n\n.config-type {\n    color: #00ff00;\n    font-weight: bold;\n}\n\n.config-changes {\n    color: #888;\n}\n\n.no-config {\n    color: #666;\n    font-style: italic;\n    text-align: center;\n    padding: 8px;\n}\n\n.preview-actions {\n    display: flex;\n    justify-content: center;\n}\n\n.apply-btn {\n    background: rgba(0, 255, 0, 0.3);\n    border: 2px solid #00ff00;\n    color: #00ff00;\n    padding: 8px 16px;\n    border-radius: 4px;\n    font-weight: bold;\n}\n\n.apply-btn:hover {\n    background: #00ff00;\n    color: #000;\n}\n\n/* Create preset modal */\n.preset-creation-modal {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.8);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    z-index: 2000;\n    pointer-events: auto;\n}\n\n.preset-creation-modal .modal-content {\n    background: #000;\n    border: none;\n    border-radius: 8px;\n    max-width: 500px;\n    width: 90vw;\n    max-height: 80vh;\n    overflow-y: auto;\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.5);\n}\n\n.preset-creation-modal .modal-header {\n    background: #00ff00;\n    color: #000;\n    padding: 12px 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: none;\n}\n\n.preset-creation-modal .modal-header h3 {\n    margin: 0;\n    font-size: 16px;\n    font-weight: bold;\n}\n\n.preset-creation-modal .modal-body {\n    padding: 20px;\n    color: #00ff00;\n}\n\n.form-group {\n    margin-bottom: 16px;\n}\n\n.form-group label {\n    display: block;\n    font-size: 12px;\n    font-weight: bold;\n    margin-bottom: 4px;\n    color: #00ff00;\n}\n\n.form-input,\n.form-textarea {\n    width: 100%;\n    background: #000;\n    color: #00ff00;\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    border-radius: 3px;\n    padding: 6px 8px;\n    font-family: inherit;\n    font-size: 12px;\n    resize: vertical;\n}\n\n.form-input:focus,\n.form-textarea:focus {\n    outline: none;\n    border-color: #00ff00;\n    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);\n}\n\n.config-source-options {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.radio-option {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    cursor: pointer;\n    font-size: 11px;\n}\n\n.radio-option input[type=\"radio\"] {\n    accent-color: #00ff00;\n}\n\n.modal-actions {\n    display: flex;\n    gap: 8px;\n    justify-content: flex-end;\n    padding: 16px 20px;\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n}\n\n.modal-actions .action-btn {\n    padding: 8px 16px;\n    font-size: 12px;\n    border-radius: 4px;\n    min-width: 80px;\n}\n\n.cancel-btn {\n    background: rgba(255, 0, 0, 0.2);\n    border: 1px solid rgba(255, 0, 0, 0.5);\n    color: #ff6666;\n}\n\n.cancel-btn:hover {\n    background: rgba(255, 0, 0, 0.3);\n    border-color: #ff0000;\n}\n\n.confirm-btn {\n    background: rgba(0, 255, 0, 0.2);\n    border: 1px solid rgba(0, 255, 0, 0.5);\n    color: #00ff00;\n}\n\n.confirm-btn:hover {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n}\n\n/* Preset manager notification */\n#preset-manager-notification {\n    position: absolute;\n    bottom: 10px;\n    left: 10px;\n    right: 10px;\n    padding: 8px;\n    border-radius: 4px;\n    font-size: 11px;\n    text-align: center;\n    opacity: 0;\n    transform: translateY(10px);\n    transition: all 0.3s ease;\n    pointer-events: none;\n}\n\n#preset-manager-notification.show {\n    opacity: 1;\n    transform: translateY(0);\n}\n\n#preset-manager-notification.success {\n    background: rgba(0, 255, 0, 0.2);\n    border: 1px solid #00ff00;\n    color: #00ff00;\n}\n\n#preset-manager-notification.error {\n    background: rgba(255, 0, 0, 0.2);\n    border: 1px solid #ff0000;\n    color: #ff6666;\n}\n\n#preset-manager-notification.info {\n    background: rgba(0, 150, 255, 0.2);\n    border: 1px solid #0096ff;\n    color: #66ccff;\n}\n\n/* Responsive adjustments for preset manager */\n@media (max-width: 768px) {\n    .ui-panel.preset-manager {\n        width: 95vw;\n        left: 2.5vw;\n        transform: none;\n        max-height: 90vh;\n    }\n    \n    .category-tabs {\n        gap: 2px;\n    }\n    \n    .category-tab {\n        padding: 4px 6px;\n        font-size: 10px;\n    }\n    \n    .tab-name {\n        display: none;\n    }\n    \n    .action-group {\n        flex-direction: column;\n    }\n    \n    .action-group .action-btn {\n        width: 100%;\n    }\n    \n    .preset-list {\n        max-height: 200px;\n    }\n}\n\n@media (max-width: 480px) {\n    .ui-panel.preset-manager {\n        width: 100vw;\n        left: 0;\n        top: 0;\n        max-height: 100vh;\n        border-radius: 0;\n    }\n    \n    .preset-manager-content {\n        max-height: calc(100vh - 60px);\n    }\n    \n    .preset-list {\n        max-height: 150px;\n    }\n    \n    .preset-item {\n        padding: 6px;\n    }\n    \n    .preset-meta {\n        flex-direction: column;\n        gap: 2px;\n    }\n    \n    .preset-creation-modal .modal-content {\n        width: 95vw;\n        margin: 10px;\n    }\n    \n    .modal-actions {\n        flex-direction: column;\n    }\n    \n    .modal-actions .action-btn {\n        width: 100%;\n    }\n}\n\n/* ===== PREVIEW SYSTEM STYLES ===== */\n.ui-panel.preview-panel {\n    top: 20px;\n    right: 20px;\n    width: 850px;\n    max-width: calc(100vw - 40px);\n    max-height: calc(100vh - 40px);\n    min-height: 600px;\n}\n\n.preview-content {\n    padding: 16px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n}\n\n/* Preview Controls */\n.preview-controls {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    align-items: center;\n    padding: 12px;\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n}\n\n.mode-controls,\n.comparison-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.control-label {\n    font-size: 12px;\n    font-weight: bold;\n    color: #00ff00;\n    white-space: nowrap;\n}\n\n.control-select {\n    background: #000;\n    border: 1px solid #00ff00;\n    color: #00ff00;\n    padding: 4px 8px;\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n    border-radius: 2px;\n}\n\n.control-select:focus {\n    outline: none;\n    box-shadow: 0 0 5px rgba(0, 255, 0, 0.5);\n}\n\n.playback-controls {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.control-btn {\n    background: rgba(0, 255, 0, 0.1);\n    border: 1px solid #00ff00;\n    color: #00ff00;\n    padding: 6px 12px;\n    font-family: 'Courier New', monospace;\n    font-size: 11px;\n    font-weight: bold;\n    border-radius: 2px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 4px;\n    transition: all 0.2s ease;\n}\n\n.control-btn:hover {\n    background: rgba(0, 255, 0, 0.2);\n    box-shadow: 0 0 5px rgba(0, 255, 0, 0.3);\n}\n\n.control-btn:active {\n    background: rgba(0, 255, 0, 0.3);\n}\n\n.control-btn .btn-icon {\n    font-size: 12px;\n}\n\n.speed-control {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    min-width: 120px;\n}\n\n.speed-control label {\n    font-size: 10px;\n    color: #00ff00;\n    font-weight: bold;\n}\n\n.speed-control input[type=\"range\"] {\n    width: 100%;\n    height: 4px;\n    background: rgba(0, 255, 0, 0.2);\n    border-radius: 2px;\n    outline: none;\n    appearance: none;\n}\n\n.speed-control input[type=\"range\"]::-webkit-slider-thumb {\n    appearance: none;\n    width: 12px;\n    height: 12px;\n    background: #00ff00;\n    border-radius: 50%;\n    cursor: pointer;\n}\n\n/* Preview Status */\n.preview-status {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.status-indicator {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    border: 1px solid #00ff00;\n}\n\n.status-indicator.active {\n    background: #00ff00;\n    box-shadow: 0 0 8px rgba(0, 255, 0, 0.6);\n    animation: pulse 1.5s ease-in-out infinite alternate;\n}\n\n.status-indicator.inactive {\n    background: transparent;\n}\n\n.status-text {\n    font-size: 12px;\n    font-weight: bold;\n}\n\n@keyframes pulse {\n    from { opacity: 1; }\n    to { opacity: 0.4; }\n}\n\n/* Preview Container */\n.preview-container {\n    flex: 1;\n    min-height: 300px;\n    border: 2px solid rgba(0, 255, 0, 0.3);\n    border-radius: 4px;\n    overflow: hidden;\n}\n\n.preview-viewport {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    position: relative;\n}\n\n.preview-viewport.split-screen {\n    flex-direction: row;\n}\n\n.preview-viewport.picture-in-picture {\n    flex-direction: column;\n}\n\n.preview-viewport.overlay {\n    position: relative;\n}\n\n/* Preview Panes */\n.preview-pane {\n    display: flex;\n    flex-direction: column;\n    background: #000;\n    border: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.preview-viewport.split-screen .preview-pane {\n    flex: 1;\n}\n\n.preview-viewport.picture-in-picture .before-pane {\n    flex: 2;\n}\n\n.preview-viewport.picture-in-picture .after-pane {\n    flex: 1;\n    position: absolute;\n    bottom: 10px;\n    right: 10px;\n    width: 200px;\n    height: 150px;\n    border: 2px solid #00ff00;\n    z-index: 10;\n}\n\n.preview-viewport.overlay .after-pane {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    opacity: 0.7;\n}\n\n.pane-header {\n    background: rgba(0, 255, 0, 0.1);\n    padding: 6px 12px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.pane-title {\n    font-size: 11px;\n    font-weight: bold;\n    color: #00ff00;\n}\n\n.pane-info {\n    font-size: 10px;\n    color: rgba(0, 255, 0, 0.7);\n}\n\n.pane-content {\n    flex: 1;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.preview-canvas {\n    border: none;\n    background: #000;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n.preview-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.3);\n    color: rgba(0, 255, 0, 0.5);\n    font-size: 12px;\n    font-weight: bold;\n    pointer-events: none;\n    transition: opacity 0.3s ease;\n}\n\n.preview-overlay.hidden {\n    opacity: 0;\n}\n\n/* Preview Details */\n.preview-details {\n    display: flex;\n    gap: 16px;\n    max-height: 200px;\n    overflow-y: auto;\n}\n\n.details-section {\n    flex: 1;\n    background: rgba(0, 255, 0, 0.05);\n    border: 1px solid rgba(0, 255, 0, 0.2);\n    border-radius: 4px;\n    padding: 12px;\n}\n\n.section-title {\n    font-size: 12px;\n    font-weight: bold;\n    color: #00ff00;\n    margin: 0 0 8px 0;\n    padding-bottom: 4px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.info-grid {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 8px;\n}\n\n.info-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 4px 0;\n}\n\n.info-label {\n    font-size: 10px;\n    font-weight: bold;\n    color: rgba(0, 255, 0, 0.8);\n}\n\n.info-value {\n    font-size: 10px;\n    color: #00ff00;\n    text-align: right;\n}\n\n/* Change Log */\n.change-log {\n    max-height: 150px;\n    overflow-y: auto;\n    border: 1px solid rgba(0, 255, 0, 0.1);\n    border-radius: 2px;\n}\n\n.log-entry {\n    display: flex;\n    gap: 8px;\n    padding: 4px 8px;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.1);\n    font-size: 10px;\n}\n\n.log-entry:last-child {\n    border-bottom: none;\n}\n\n.log-entry.error {\n    background: rgba(255, 0, 0, 0.1);\n    color: #ff6666;\n}\n\n.log-entry.warning {\n    background: rgba(255, 255, 0, 0.1);\n    color: #ffff66;\n}\n\n.log-time {\n    color: rgba(0, 255, 0, 0.6);\n    font-weight: normal;\n    white-space: nowrap;\n    min-width: 60px;\n}\n\n.log-message {\n    color: #00ff00;\n    flex: 1;\n}\n\n/* Comparison Mode Adjustments */\n.preview-viewport.comparison-side-by-side .preview-pane {\n    border-right: 2px solid #00ff00;\n}\n\n.preview-viewport.comparison-side-by-side .preview-pane:last-child {\n    border-right: none;\n}\n\n.preview-viewport.comparison-before-after .after-pane {\n    transition: opacity 0.5s ease;\n}\n\n.preview-viewport.comparison-overlay .before-pane {\n    opacity: 0.5;\n}\n\n/* Responsive Design */\n@media (max-width: 1024px) {\n    .ui-panel.preview-panel {\n        width: calc(100vw - 20px);\n        right: 10px;\n        max-height: calc(100vh - 20px);\n    }\n    \n    .preview-controls {\n        flex-direction: column;\n        align-items: stretch;\n        gap: 12px;\n    }\n    \n    .playback-controls {\n        justify-content: space-between;\n    }\n    \n    .info-grid {\n        grid-template-columns: 1fr;\n    }\n    \n    .preview-details {\n        flex-direction: column;\n    }\n}\n\n@media (max-width: 768px) {\n    .preview-viewport.split-screen {\n        flex-direction: column;\n    }\n    \n    .preview-viewport.picture-in-picture .after-pane {\n        position: relative;\n        width: 100%;\n        height: 200px;\n        bottom: auto;\n        right: auto;\n    }\n    \n    .preview-canvas {\n        width: 100%;\n        height: auto;\n        max-height: 200px;\n    }\n}\n\n@media (max-width: 480px) {\n    .ui-panel.preview-panel {\n        width: 100vw;\n        right: 0;\n        top: 0;\n        max-height: 100vh;\n        border-radius: 0;\n    }\n    \n    .preview-content {\n        padding: 12px;\n        gap: 12px;\n    }\n    \n    .preview-controls {\n        padding: 8px;\n        gap: 8px;\n    }\n    \n    .control-btn {\n        padding: 4px 8px;\n        font-size: 10px;\n    }\n    \n    .preview-details {\n        max-height: 150px;\n    }\n    \n    .change-log {\n        max-height: 100px;\n    }\n}\n\n/* ===== TRACK EDITOR STYLES ===== */\n.track-editor-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100vw;\n    height: 100vh;\n    background: rgba(0, 0, 0, 0.95);\n    z-index: 2000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    backdrop-filter: blur(10px);\n}\n\n.track-editor-container {\n    width: 95vw;\n    height: 95vh;\n    background: rgba(0, 0, 0, 0.9);\n    border: 2px solid #00ff00;\n    border-radius: 8px;\n    display: flex;\n    flex-direction: column;\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.4);\n}\n\n.track-editor-container.minimized .editor-sidebar {\n    display: none;\n}\n\n.editor-header {\n    background: #00ff00;\n    color: #000;\n    padding: 12px 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 2px solid #00ff00;\n}\n\n.editor-title {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.title-text {\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.editor-status {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    font-size: 12px;\n}\n\n.status-indicator {\n    color: #666;\n    font-size: 10px;\n}\n\n.track-info {\n    font-weight: bold;\n}\n\n.editor-controls {\n    display: flex;\n    gap: 8px;\n}\n\n.editor-toolbar {\n    background: rgba(0, 255, 0, 0.1);\n    border-bottom: 1px solid rgba(0, 255, 0, 0.3);\n    padding: 12px 16px;\n    display: flex;\n    gap: 24px;\n    align-items: center;\n    flex-wrap: wrap;\n}\n\n.tool-group {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.tool-group-label {\n    font-size: 10px;\n    color: #888;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.tool-palette {\n    display: flex;\n    gap: 4px;\n}\n\n.tool-btn {\n    background: rgba(0, 0, 0, 0.8);\n    border: 1px solid #333;\n    color: #00ff00;\n    padding: 8px 12px;\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 4px;\n    transition: all 0.2s ease;\n    min-width: 60px;\n}\n\n.tool-btn:hover {\n    border-color: #00ff00;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n.tool-btn.active {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n    color: #000;\n}\n\n.tool-icon {\n    font-size: 16px;\n}\n\n.tool-name {\n    font-size: 9px;\n    text-transform: uppercase;\n}\n\n.brush-size-selector {\n    display: flex;\n    gap: 4px;\n}\n\n.brush-size-btn {\n    background: rgba(0, 0, 0, 0.8);\n    border: 1px solid #333;\n    color: #00ff00;\n    padding: 6px 10px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 11px;\n    transition: all 0.2s ease;\n    min-width: 40px;\n}\n\n.brush-size-btn:hover {\n    border-color: #00ff00;\n    background: rgba(0, 255, 0, 0.1);\n}\n\n.brush-size-btn.active {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n    color: #000;\n}\n\n.view-controls {\n    display: flex;\n    gap: 4px;\n    align-items: center;\n}\n\n.zoom-level {\n    font-size: 12px;\n    color: #00ff00;\n    min-width: 45px;\n    text-align: center;\n}\n\n.action-controls {\n    display: flex;\n    gap: 4px;\n}\n\n.editor-main {\n    flex: 1;\n    display: flex;\n    overflow: hidden;\n}\n\n.canvas-container {\n    flex: 1;\n    position: relative;\n    background: #111;\n    border-right: 1px solid rgba(0, 255, 0, 0.3);\n    overflow: hidden;\n}\n\n.canvas-container.drag-over {\n    background: rgba(0, 255, 0, 0.1);\n    border: 2px dashed #00ff00;\n}\n\n.editor-canvas {\n    display: block;\n    max-width: 100%;\n    max-height: 100%;\n    cursor: crosshair;\n    image-rendering: pixelated;\n}\n\n.canvas-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    pointer-events: none;\n}\n\n.grid-overlay {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background-image: \n        linear-gradient(rgba(0, 255, 0, 0.1) 1px, transparent 1px),\n        linear-gradient(90deg, rgba(0, 255, 0, 0.1) 1px, transparent 1px);\n    background-size: 50px 50px;\n}\n\n.crosshair {\n    position: absolute;\n    width: 20px;\n    height: 20px;\n    border: 1px solid #00ff00;\n    transform: translate(-50%, -50%);\n    pointer-events: none;\n    opacity: 0.7;\n}\n\n.crosshair::before,\n.crosshair::after {\n    content: '';\n    position: absolute;\n    background: #00ff00;\n}\n\n.crosshair::before {\n    top: 50%;\n    left: 0;\n    right: 0;\n    height: 1px;\n    transform: translateY(-50%);\n}\n\n.crosshair::after {\n    left: 50%;\n    top: 0;\n    bottom: 0;\n    width: 1px;\n    transform: translateX(-50%);\n}\n\n.editor-sidebar {\n    width: 280px;\n    background: rgba(0, 0, 0, 0.9);\n    border-left: 1px solid rgba(0, 255, 0, 0.3);\n    display: flex;\n    flex-direction: column;\n    overflow-y: auto;\n}\n\n.sidebar-section {\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.section-header {\n    background: rgba(0, 255, 0, 0.1);\n    padding: 8px 12px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    border-bottom: 1px solid rgba(0, 255, 0, 0.2);\n}\n\n.section-title {\n    font-size: 12px;\n    font-weight: bold;\n    color: #00ff00;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n.toggle-btn {\n    background: none;\n    border: none;\n    color: #00ff00;\n    cursor: pointer;\n    font-size: 14px;\n    padding: 2px;\n}\n\n.minimap-section {\n    min-height: 150px;\n}\n\n.minimap-container {\n    padding: 12px;\n    position: relative;\n}\n\n.minimap-canvas {\n    width: 100%;\n    height: 100px;\n    border: 1px solid #333;\n    background: #000;\n    image-rendering: pixelated;\n}\n\n.viewport-indicator {\n    position: absolute;\n    border: 2px solid #00ff00;\n    background: rgba(0, 255, 0, 0.1);\n    pointer-events: none;\n}\n\n.track-properties {\n    padding: 12px;\n}\n\n.property-group {\n    margin-bottom: 12px;\n}\n\n.property-label {\n    display: block;\n    font-size: 11px;\n    color: #888;\n    margin-bottom: 4px;\n    text-transform: uppercase;\n}\n\n.property-input,\n.property-select,\n.property-textarea {\n    width: 100%;\n    background: rgba(0, 0, 0, 0.8);\n    border: 1px solid #333;\n    color: #00ff00;\n    padding: 6px 8px;\n    border-radius: 3px;\n    font-family: inherit;\n    font-size: 12px;\n}\n\n.property-input:focus,\n.property-select:focus,\n.property-textarea:focus {\n    outline: none;\n    border-color: #00ff00;\n    background: rgba(0, 255, 0, 0.05);\n}\n\n.property-textarea {\n    resize: vertical;\n    min-height: 60px;\n}\n\n.editor-settings {\n    padding: 12px;\n}\n\n.setting-group {\n    margin-bottom: 8px;\n}\n\n.setting-checkbox {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 12px;\n    color: #ccc;\n}\n\n.setting-checkbox input[type=\"checkbox\"] {\n    display: none;\n}\n\n.checkbox-custom {\n    width: 16px;\n    height: 16px;\n    border: 1px solid #333;\n    background: rgba(0, 0, 0, 0.8);\n    border-radius: 2px;\n    position: relative;\n    transition: all 0.2s ease;\n}\n\n.setting-checkbox input[type=\"checkbox\"]:checked + .checkbox-custom {\n    background: rgba(0, 255, 0, 0.3);\n    border-color: #00ff00;\n}\n\n.setting-checkbox input[type=\"checkbox\"]:checked + .checkbox-custom::after {\n    content: '✓';\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    color: #00ff00;\n    font-size: 12px;\n    font-weight: bold;\n}\n\n.editor-footer {\n    background: rgba(0, 255, 0, 0.1);\n    border-top: 1px solid rgba(0, 255, 0, 0.3);\n    padding: 12px 16px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 16px;\n}\n\n.file-actions,\n.preview-actions {\n    display: flex;\n    gap: 8px;\n}\n\n.action-btn {\n    background: rgba(0, 0, 0, 0.8);\n    border: 1px solid #333;\n    color: #00ff00;\n    padding: 8px 16px;\n    border-radius: 4px;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    transition: all 0.2s ease;\n    text-transform: uppercase;\n    font-weight: bold;\n}\n\n.action-btn:hover {\n    border-color: #00ff00;\n    background: rgba(0, 255, 0, 0.1);\n    transform: translateY(-1px);\n}\n\n.action-btn:disabled {\n    opacity: 0.5;\n    cursor: not-allowed;\n    transform: none;\n}\n\n.action-btn.primary-btn {\n    background: rgba(0, 255, 0, 0.2);\n    border-color: #00ff00;\n}\n\n.action-btn.primary-btn:hover {\n    background: rgba(0, 255, 0, 0.4);\n}\n\n.preview-btn {\n    background: rgba(0, 255, 255, 0.2);\n    border-color: #00ffff;\n    color: #00ffff;\n}\n\n.preview-btn:hover {\n    background: rgba(0, 255, 255, 0.4);\n}\n\n.test-btn {\n    background: rgba(255, 255, 0, 0.2);\n    border-color: #ffff00;\n    color: #ffff00;\n}\n\n.test-btn:hover {\n    background: rgba(255, 255, 0, 0.4);\n}\n\n.btn-icon {\n    font-size: 14px;\n}\n\n/* Track Editor Notifications */\n#track-editor-notification {\n    position: absolute;\n    top: 20px;\n    right: 20px;\n    background: rgba(0, 0, 0, 0.9);\n    border: 1px solid #333;\n    border-radius: 4px;\n    padding: 12px 16px;\n    color: #00ff00;\n    font-size: 12px;\n    transform: translateX(100%);\n    opacity: 0;\n    transition: all 0.3s ease;\n    z-index: 3000;\n    max-width: 300px;\n}\n\n#track-editor-notification.show {\n    transform: translateX(0);\n    opacity: 1;\n}\n\n#track-editor-notification.success {\n    border-color: #00ff00;\n    color: #00ff00;\n}\n\n#track-editor-notification.error {\n    border-color: #ff0000;\n    color: #ff0000;\n}\n\n#track-editor-notification.warn {\n    border-color: #ffff00;\n    color: #ffff00;\n}\n\n#track-editor-notification.info {\n    border-color: #00ffff;\n    color: #00ffff;\n}\n\n/* Responsive Track Editor */\n@media (max-width: 1200px) {\n    .track-editor-container {\n        width: 98vw;\n        height: 98vh;\n    }\n    \n    .editor-sidebar {\n        width: 240px;\n    }\n    \n    .editor-toolbar {\n        flex-wrap: wrap;\n        gap: 16px;\n    }\n    \n    .tool-btn {\n        min-width: 50px;\n        padding: 6px 8px;\n    }\n    \n    .tool-name {\n        display: none;\n    }\n}\n\n@media (max-width: 800px) {\n    .track-editor-container {\n        width: 100vw;\n        height: 100vh;\n        border-radius: 0;\n    }\n    \n    .editor-toolbar {\n        padding: 8px 12px;\n        gap: 12px;\n    }\n    \n    .tool-group {\n        gap: 4px;\n    }\n    \n    .editor-sidebar {\n        width: 200px;\n    }\n    \n    .editor-footer {\n        flex-direction: column;\n        gap: 12px;\n    }\n    \n    .file-actions,\n    .preview-actions {\n        width: 100%;\n        justify-content: center;\n    }\n}\n\n/* ===== TRACK PREVIEW STYLES ===== */\n.track-preview-panel {\n    position: fixed;\n    top: 50px;\n    right: 50px;\n    width: 80vw;\n    height: 80vh;\n    background: rgba(0, 0, 0, 0.95);\n    border: none;\n    border-radius: 8px;\n    backdrop-filter: blur(10px);\n    box-shadow: 0 0 30px rgba(0, 255, 0, 0.4);\n    z-index: 2000;\n    font-family: 'Courier New', monospace;\n    color: #00ff00;\n    overflow: hidden;\n}\n\n.preview-container {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.preview-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    background: #00ff00;\n    color: #000;\n    padding: 12px 16px;\n    border-bottom: 2px solid #00ff00;\n}\n\n.preview-title {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.preview-title .title-text {\n    font-size: 18px;\n    font-weight: bold;\n}\n\n.preview-status {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    font-size: 12px;\n}\n\n.status-indicator {\n    width: 8px;\n    height: 8px;\n    border-radius: 50%;\n    background: #666;\n}\n\n.status-indicator.active {\n    background: #ff0000;\n    animation: pulse 1s infinite;\n}\n\n.status-indicator.inactive {\n    background: #666;\n}\n\n@keyframes pulse {\n    0%, 100% { opacity: 1; }\n    50% { opacity: 0.5; }\n}\n\n.fps-counter {\n    font-family: 'Courier New', monospace;\n    font-size: 11px;\n    color: #000;\n    background: rgba(255, 255, 255, 0.2);\n    padding: 2px 6px;\n    border-radius: 3px;\n}\n\n.preview-controls-header {\n    display: flex;\n    gap: 8px;\n}\n\n.preview-controls-header .control-btn {\n    background: #000;\n    color: #00ff00;\n    border: 1px solid #00ff00;\n    border-radius: 4px;\n    padding: 6px 10px;\n    cursor: pointer;\n    font-family: 'Courier New', monospace;\n    font-size: 12px;\n    transition: all 0.2s;\n}\n\n.preview-controls-header .control-btn:hover {\n    background: #00ff00;\n    color: #000;\n}\n\n.preview-body {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    padding: 16px;\n    gap: 16px;\n    overflow: hidden;\n}\n\n.preview-main {\n    display: flex;\n    gap: 16px;\n    flex: 1;\n    min-height: 0;\n}\n\n.preview-viewport {\n    flex: 1;\n    position: relative;\n    background: #000;\n    border: 2px solid #00ff00;\n    border-radius: 4px;\n    overflow: hidden;\n    min-height: 400px;\n}\n\n.preview-canvas,\n.preview-overlay-canvas {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    image-rendering: pixelated;\n    image-rendering: -moz-crisp-edges;\n    image-rendering: crisp-edges;\n}\n\n.preview-overlay-canvas {\n    pointer-events: none;\n    z-index: 1;\n}\n\n.preview-info-overlay {\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    right: 8px;\n    display: flex;\n    justify-content: space-between;\n    align-items: flex-start;\n    pointer-events: none;\n    z-index: 2;\n}\n\n.zoom-controls {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    background: rgba(0, 0, 0, 0.8);\n    border: 1px solid #00ff00;\n    border-radius: 4px;\n    padding: 4px 8px;\n    font-size: 12px;\n    pointer-events: auto;\n}\n\n.zoom-btn {\n    background: transparent;\n    color: #00ff00;\n    border: 1px solid #00ff00;\n    border-radius: 2px;\n    padding: 2px 6px;\n    cursor: pointer;\n    font-family: 'Courier New', monospace;\n    font-size: 10px;\n    transition: all 0.2s;\n}\n\n.zoom-btn:hover {\n    background: #00ff00;\n    color: #000;\n}\n\n.zoom-level {\n    color: #00ff00;\n    font-size: 10px;\n    min-width: 30px;\n    text-align: center;\n}\n\n.preview-sidebar {\n    width: 300px;\n    background: rgba(0, 20, 0, 0.8);\n    border: 1px solid #00ff00;\n    border-radius: 4px;\n    padding: 16px;\n    overflow-y: auto;\n    max-height: 100%;\n}\n\n.sidebar-section {\n    margin-bottom: 24px;\n}\n\n.sidebar-section:last-child {\n    margin-bottom: 0;\n}\n\n.section-title {\n    color: #00ff00;\n    font-size: 14px;\n    font-weight: bold;\n    margin-bottom: 12px;\n    border-bottom: 1px solid #00ff00;\n    padding-bottom: 4px;\n}\n\n.settings-grid {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    margin-bottom: 16px;\n}\n\n.setting-item {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    cursor: pointer;\n    font-size: 12px;\n}\n\n.setting-item input[type=\"checkbox\"] {\n    width: 14px;\n    height: 14px;\n    accent-color: #00ff00;\n}\n\n.setting-label {\n    color: #00ff00;\n    user-select: none;\n}\n\n.setting-group {\n    margin-bottom: 12px;\n}\n\n.setting-group .setting-label {\n    display: block;\n    margin-bottom: 6px;\n    font-size: 12px;\n}\n\n.setting-slider {\n    width: 100%;\n    accent-color: #00ff00;\n    background: #333;\n}\n\n.validation-results,\n.performance-metrics {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.validation-item,\n.metric-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    font-size: 11px;\n    padding: 4px 0;\n}\n\n.validation-label,\n.metric-label {\n    color: #ccc;\n}\n\n.validation-status {\n    font-weight: bold;\n    text-transform: uppercase;\n    font-size: 10px;\n    padding: 2px 6px;\n    border-radius: 2px;\n}\n\n.validation-status.valid {\n    color: #00ff00;\n    background: rgba(0, 255, 0, 0.2);\n    border: 1px solid #00ff00;\n}\n\n.validation-status.invalid {\n    color: #ff0000;\n    background: rgba(255, 0, 0, 0.2);\n    border: 1px solid #ff0000;\n}\n\n.validation-status.unknown {\n    color: #ffff00;\n    background: rgba(255, 255, 0, 0.2);\n    border: 1px solid #ffff00;\n}\n\n.metric-value {\n    color: #00ff00;\n    font-weight: bold;\n    font-family: 'Courier New', monospace;\n}\n\n/* Live Preview Button in Track Editor */\n.live-preview-btn {\n    background: linear-gradient(135deg, #000 0%, #003300 100%);\n    border: 2px solid #00ff00;\n    color: #00ff00;\n    box-shadow: 0 0 10px rgba(0, 255, 0, 0.3);\n}\n\n.live-preview-btn:hover {\n    background: linear-gradient(135deg, #00ff00 0%, #00cc00 100%);\n    color: #000;\n    box-shadow: 0 0 15px rgba(0, 255, 0, 0.5);\n}\n\n/* Responsive Design for Track Preview */\n@media (max-width: 1200px) {\n    .track-preview-panel {\n        width: 90vw;\n        height: 85vh;\n        top: 30px;\n        right: 30px;\n    }\n    \n    .preview-sidebar {\n        width: 250px;\n    }\n    \n    .preview-main {\n        flex-direction: column;\n    }\n    \n    .preview-viewport {\n        min-height: 300px;\n    }\n}\n\n@media (max-width: 800px) {\n    .track-preview-panel {\n        width: 95vw;\n        height: 90vh;\n        top: 20px;\n        right: 20px;\n    }\n    \n    .preview-main {\n        flex-direction: column;\n    }\n    \n    .preview-sidebar {\n        width: 100%;\n        max-height: 200px;\n    }\n    \n    .preview-viewport {\n        min-height: 200px;\n    }\n    \n    .settings-grid {\n        display: grid;\n        grid-template-columns: 1fr 1fr;\n        gap: 6px;\n    }\n    \n    .section-title {\n        font-size: 12px;\n    }\n    \n    .setting-item {\n        font-size: 11px;\n    }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
